import { IExhibitor } from '../models/exhibitor.model.i';

export const EXHIBITORS: Array<[number, IExhibitor]> = [[3415, {
    'name': 'AB AntonBogner',
    'description': '',
    'city': 'Grafenau',
    'id': 3415,
    'blockId': 34,
    'queryName': 'ab antonbogner'
}], [1321, {
    'name': 'ABACUS Nachhilfeinstitut',
    'description': '',
    'city': 'München',
    'id': 1321,
    'blockId': 13,
    'queryName': 'abacus nachhilfeinstitut'
}], [1403, {
    'name': 'Adam  Warenhandelsges. m.b.H.',
    'description': '',
    'city': 'Füssen im Allgäu',
    'id': 1403,
    'blockId': 14,
    'queryName': 'adam  warenhandelsges. m.b.h.'
}], [7502, {
    'name': 'Adama Deutschland GmbH',
    'description': '',
    'city': 'Köln',
    'id': 7502,
    'blockId': 75,
    'queryName': 'adama deutschland gmbh'
}], [7303, {
    'name': 'ADDCON GmbH',
    'description': '',
    'city': 'Bitterfeld',
    'id': 7303,
    'blockId': 73,
    'queryName': 'addcon gmbh'
}], [1412, {
    'name': 'AFG Reinigungssysteme',
    'description': '',
    'city': 'Donauwörth',
    'id': 1412,
    'blockId': 14,
    'queryName': 'afg reinigungssysteme'
}], [5103, {
    'name': 'AFM Forst- u. Krantechnik GmbH',
    'description': '',
    'city': 'Haselbach',
    'id': 5103,
    'blockId': 51,
    'queryName': 'afm forst- u. krantechnik gmbh'
}], [8505, {
    'name': 'agaSaat Hybrid GmbH',
    'description': '',
    'city': 'Neukirchen - Vluyn',
    'id': 8505,
    'blockId': 85,
    'queryName': 'agasaat hybrid gmbh'
}], [3603, {
    'name': 'AGCO Deutschland GmbH',
    'description': '',
    'city': 'Marktoberdorf',
    'id': 3603,
    'blockId': 36,
    'queryName': 'agco deutschland gmbh'
}], [3719, {
    'name': 'Aggretech GmbH & Co. KG',
    'description': '',
    'city': 'Salzweg',
    'id': 3719,
    'blockId': 37,
    'queryName': 'aggretech gmbh & co. kg'
}], [2703, {
    'name': 'Agrarsysteme Hornung GmbH & Co. KG',
    'description': '',
    'city': 'Zöbingen',
    'id': 2703,
    'blockId': 27,
    'queryName': 'agrarsysteme hornung gmbh & co. kg'
}], [4404, {
    'name': 'Agrartechnik Grabmeier GmbH',
    'description': '',
    'city': 'Reisbach',
    'id': 4404,
    'blockId': 44,
    'queryName': 'agrartechnik grabmeier gmbh'
}], [4202, {
    'name': 'AGRATEC Straubing',
    'description': '',
    'city': 'Salching',
    'id': 4202,
    'blockId': 42,
    'queryName': 'agratec straubing'
}], [7206, {
    'name': 'AGRAVIS Raiffeisen AG',
    'description': '',
    'city': 'Münster',
    'id': 7206,
    'blockId': 72,
    'queryName': 'agravis raiffeisen ag'
}], [2610, {
    'name': 'AGREL GmbH',
    'description': '',
    'city': 'Arnstorf',
    'id': 2610,
    'blockId': 26,
    'queryName': 'agrel gmbh'
}], [3417, {
    'name': 'AGRIA Verkaufsbüro Süd',
    'description': '',
    'city': 'Ergoldsbach',
    'id': 3417,
    'blockId': 34,
    'queryName': 'agria verkaufsbüro süd'
}], [3746, {
    'name': 'Agrimont Bohemia s.r.o.',
    'description': '',
    'city': 'Luzec n. Vlatavou',
    'id': 3746,
    'blockId': 37,
    'queryName': 'agrimont bohemia s.r.o.'
}], [2701, {
    'name': 'AGRIPP GmbH + Co. KG',
    'description': '',
    'city': 'Welver',
    'id': 2701,
    'blockId': 27,
    'queryName': 'agripp gmbh + co. kg'
}], [7501, {
    'name': 'Agromais GmbH',
    'description': '',
    'city': 'Everswinkel',
    'id': 7501,
    'blockId': 75,
    'queryName': 'agromais gmbh'
}], [3722, {
    'name': 'Agrotec Schupfen GmbH',
    'description': '',
    'city': 'Seeham',
    'id': 3722,
    'blockId': 37,
    'queryName': 'agrotec schupfen gmbh'
}], [7308, {
    'name': 'AGROTEL GmbH',
    'description': '',
    'city': 'Neuhaus a. Inn',
    'id': 7308,
    'blockId': 73,
    'queryName': 'agrotel gmbh'
}], [1214, {
    'name': 'Airvital e.K.',
    'description': '',
    'city': 'Kassel',
    'id': 1214,
    'blockId': 12,
    'queryName': 'airvital e.k.'
}], [3207, {
    'name': 'Akrar',
    'description': '',
    'city': 'Königsberg',
    'id': 3207,
    'blockId': 32,
    'queryName': 'akrar'
}], [2002, {
    'name': 'Albrecht',
    'description': '',
    'city': 'Durach',
    'id': 2002,
    'blockId': 20,
    'queryName': 'albrecht'
}], [2101, {
    'name': 'Alö Deutschland Vertriebs GmbH',
    'description': '',
    'city': 'Dieburg',
    'id': 2101,
    'blockId': 21,
    'queryName': 'alö deutschland vertriebs gmbh'
}], [4109, {
    'name': 'ALPEGO SPA',
    'description': '',
    'city': 'Lonigo',
    'id': 4109,
    'blockId': 41,
    'queryName': 'alpego spa'
}], [5511, {
    'name': 'Alvatec GmbH & Co. KG',
    'description': '',
    'city': 'Schechen',
    'id': 5511,
    'blockId': 55,
    'queryName': 'alvatec gmbh & co. kg'
}], [7506, {
    'name': 'AlzChem Trostberg GmbH',
    'description': '',
    'city': 'Trostberg',
    'id': 7506,
    'blockId': 75,
    'queryName': 'alzchem trostberg gmbh'
}], [4301, {
    'name': 'Amazonen-Werke',
    'description': '',
    'city': 'Hasbergen-Gaste',
    'id': 4301,
    'blockId': 43,
    'queryName': 'amazonen-werke'
}], [1514, {
    'name': 'Ambiente',
    'description': '',
    'city': 'Weiden',
    'id': 1514,
    'blockId': 15,
    'queryName': 'ambiente'
}], [1413, {
    'name': 'AMC',
    'description': '',
    'city': 'Mamming',
    'id': 1413,
    'blockId': 14,
    'queryName': 'amc'
}], [5605, {
    'name': 'Ammboss Holzspalter',
    'description': '',
    'city': 'Ergoldsbach',
    'id': 5605,
    'blockId': 56,
    'queryName': 'ammboss holzspalter'
}], [5208, {
    'name': 'Ammboss Holzspalter',
    'description': '',
    'city': 'Ergoldsbach',
    'id': 5208,
    'blockId': 52,
    'queryName': 'ammboss holzspalter'
}], [3733, {
    'name': 'Anaergia Technologies GmbH',
    'description': '',
    'city': 'Lippetal',
    'id': 3733,
    'blockId': 37,
    'queryName': 'anaergia technologies gmbh'
}], [1225, {
    'name': 'Apfel',
    'description': '',
    'city': 'Bad Griesbach',
    'id': 1225,
    'blockId': 12,
    'queryName': 'apfel'
}], [4214, {
    'name': 'APV - Technische Produkte GmbH',
    'description': '',
    'city': 'Hötzelsdorf',
    'id': 4214,
    'blockId': 42,
    'queryName': 'apv - technische produkte gmbh'
}], [3738, {
    'name': 'Argo GmbH',
    'description': '',
    'city': 'Burgoberbach',
    'id': 3738,
    'blockId': 37,
    'queryName': 'argo gmbh'
}], [1303, {
    'name': 'ARMSTARK Handels GmbH',
    'description': '',
    'city': 'Tettenweis',
    'id': 1303,
    'blockId': 13,
    'queryName': 'armstark handels gmbh'
}], [1304, {
    'name': 'ARMSTARK Handels GmbH',
    'description': '',
    'city': 'Tettenweis',
    'id': 1304,
    'blockId': 13,
    'queryName': 'armstark handels gmbh'
}], [5607, {
    'name': 'Ascenso Tyres CE GmbH',
    'description': '',
    'city': 'Wallenhorst',
    'id': 5607,
    'blockId': 56,
    'queryName': 'ascenso tyres ce gmbh'
}], [5705, {
    'name': 'ATG Agrartechnikgeräte GmbH',
    'description': '',
    'city': 'Hörsching',
    'id': 5705,
    'blockId': 57,
    'queryName': 'atg agrartechnikgeräte gmbh'
}], [2603, {
    'name': 'Baier Stoi',
    'description': '',
    'city': 'Arnbruck',
    'id': 2603,
    'blockId': 26,
    'queryName': 'baier stoi'
}], [3411, {
    'name': 'BalleMax GmbH',
    'description': '',
    'city': 'Waldkirch',
    'id': 3411,
    'blockId': 34,
    'queryName': 'ballemax gmbh'
}], [5606, {
    'name': 'BaSt-Ing GmbH',
    'description': '',
    'city': 'Lenggries',
    'id': 5606,
    'blockId': 56,
    'queryName': 'bast-ing gmbh'
}], [8410, {
    'name': 'Bauer',
    'description': '',
    'city': 'Hebertsfelden',
    'id': 8410,
    'blockId': 84,
    'queryName': 'bauer'
}], [2708, {
    'name': 'Bauer GmbH',
    'description': '',
    'city': 'Voitsberg',
    'id': 2708,
    'blockId': 27,
    'queryName': 'bauer gmbh'
}], [1711, {
    'name': 'Baumgartner',
    'description': '',
    'city': 'Oberneukirchen',
    'id': 1711,
    'blockId': 17,
    'queryName': 'baumgartner'
}], [3422, {
    'name': 'Baumgartner',
    'description': '',
    'city': 'Kirchanschöring',
    'id': 3422,
    'blockId': 34,
    'queryName': 'baumgartner'
}], [8403, {
    'name': 'Baumgartner & Schönherr',
    'description': '',
    'city': 'Eggenfelden',
    'id': 8403,
    'blockId': 84,
    'queryName': 'baumgartner & schönherr'
}], [1801, {
    'name': 'Baumgartner Fenster + Haustüren',
    'description': '',
    'city': 'Haarbach',
    'id': 1801,
    'blockId': 18,
    'queryName': 'baumgartner fenster + haustüren'
}], [7305, {
    'name': 'Baumgartner GmbH & Co KG',
    'description': '',
    'city': 'Ramsau',
    'id': 7305,
    'blockId': 73,
    'queryName': 'baumgartner gmbh & co kg'
}], [2505, {
    'name': 'Baumgartner Landtechnik',
    'description': '',
    'city': 'Frontenhausen',
    'id': 2505,
    'blockId': 25,
    'queryName': 'baumgartner landtechnik'
}], [7511, {
    'name': 'Bayer Crop Science Deutschland  GmbH',
    'description': '',
    'city': 'Monheim',
    'id': 7511,
    'blockId': 75,
    'queryName': 'bayer crop science deutschland  gmbh'
}], [7402, {
    'name': 'Bayerische Futtersaatbau GmbH',
    'description': '',
    'city': 'Ismaning',
    'id': 7402,
    'blockId': 74,
    'queryName': 'bayerische futtersaatbau gmbh'
}], [2103, {
    'name': 'BayWa AG',
    'description': '',
    'city': 'Obertraubling',
    'id': 2103,
    'blockId': 21,
    'queryName': 'baywa ag'
}], [4105, {
    'name': 'BB - Umwelttechnik GmbH',
    'description': '',
    'city': 'Roßhaupten',
    'id': 4105,
    'blockId': 41,
    'queryName': 'bb - umwelttechnik gmbh'
}], [1221, {
    'name': 'Beam GmbH',
    'description': '',
    'city': 'Altenstadt',
    'id': 1221,
    'blockId': 12,
    'queryName': 'beam gmbh'
}], [1215, {
    'name': 'Beam your life',
    'description': '',
    'city': 'Holzkirchen',
    'id': 1215,
    'blockId': 12,
    'queryName': 'beam your life'
}], [3419, {
    'name': 'Becker Agrartechnik GmbH',
    'description': '',
    'city': 'Seesen',
    'id': 3419,
    'blockId': 34,
    'queryName': 'becker agrartechnik gmbh'
}], [5504, {
    'name': 'BEHA Bau- und Forsttechnik',
    'description': '',
    'city': 'Steinach',
    'id': 5504,
    'blockId': 55,
    'queryName': 'beha bau- und forsttechnik'
}], [1418, {
    'name': 'Bela Aqua Vertriebspartner',
    'description': '',
    'city': 'Tann',
    'id': 1418,
    'blockId': 14,
    'queryName': 'bela aqua vertriebspartner'
}], [3303, {
    'name': 'Bergmann GmbH',
    'description': '',
    'city': 'Goldenstedt',
    'id': 3303,
    'blockId': 33,
    'queryName': 'bergmann gmbh'
}], [7408, {
    'name': 'Bergophor-Futtermittelfabrik',
    'description': '',
    'city': 'Kulmbach',
    'id': 7408,
    'blockId': 74,
    'queryName': 'bergophor-futtermittelfabrik'
}], [8905, {
    'name': 'Bernhard',
    'description': '',
    'city': 'Edling',
    'id': 8905,
    'blockId': 89,
    'queryName': 'bernhard'
}], [5101, {
    'name': 'Best - Neuheiten',
    'description': '',
    'city': 'Moosburg',
    'id': 5101,
    'blockId': 51,
    'queryName': 'best - neuheiten'
}], [3706, {
    'name': 'BHKW Johann Hochreiter',
    'description': '',
    'city': 'Schnaitsee',
    'id': 3706,
    'blockId': 37,
    'queryName': 'bhkw johann hochreiter'
}], [7107, {
    'name': 'Big Dutchman International GmbH',
    'description': '',
    'city': 'Vechta',
    'id': 7107,
    'blockId': 71,
    'queryName': 'big dutchman international gmbh'
}], [1211, {
    'name': 'Biller Aufzugdienst Rottal Gmbh',
    'description': '',
    'city': 'Malching',
    'id': 1211,
    'blockId': 12,
    'queryName': 'biller aufzugdienst rottal gmbh'
}], [1315, {
    'name': 'Biller GmbH',
    'description': '',
    'city': 'Eching',
    'id': 1315,
    'blockId': 13,
    'queryName': 'biller gmbh'
}], [1713, {
    'name': 'BillerZaunbau GbR',
    'description': '',
    'city': 'Neuhaus a. Inn',
    'id': 1713,
    'blockId': 17,
    'queryName': 'billerzaunbau gbr'
}], [5708, {
    'name': 'Binderberger Maschinenbau GmbH',
    'description': '',
    'city': 'Georgen',
    'id': 5708,
    'blockId': 57,
    'queryName': 'binderberger maschinenbau gmbh'
}], [3724, {
    'name': 'BioG GmbH',
    'description': '',
    'city': 'Utzenaich',
    'id': 3724,
    'blockId': 37,
    'queryName': 'biog gmbh'
}], [2416, {
    'name': 'Bioland Landesverband Bayern e.V.',
    'description': '',
    'city': 'Augsburg',
    'id': 2416,
    'blockId': 24,
    'queryName': 'bioland landesverband bayern e.v.'
}], [8603, {
    'name': 'Biolchim Deutschland GmbH',
    'description': '',
    'city': 'Hannover',
    'id': 8603,
    'blockId': 86,
    'queryName': 'biolchim deutschland gmbh'
}], [1201, {
    'name': 'Blaschek',
    'description': '',
    'city': 'Garching/Alz',
    'id': 1201,
    'blockId': 12,
    'queryName': 'blaschek'
}], [4103, {
    'name': 'Böck Silosysteme GmbH',
    'description': '',
    'city': 'Tacherting',
    'id': 4103,
    'blockId': 41,
    'queryName': 'böck silosysteme gmbh'
}], [3307, {
    'name': 'Bohnenkamp AG',
    'description': '',
    'city': 'Osnabrück',
    'id': 3307,
    'blockId': 33,
    'queryName': 'bohnenkamp ag'
}], [3718, {
    'name': 'Bomech BV',
    'description': '',
    'city': 'SH Albergen',
    'id': 3718,
    'blockId': 37,
    'queryName': 'bomech bv'
}], [7512, {
    'name': 'Borealis L.A.T',
    'description': '',
    'city': 'Linz',
    'id': 7512,
    'blockId': 75,
    'queryName': 'borealis l.a.t'
}], [3709, {
    'name': 'Brand Rühr- und Pumptechnik GmbH',
    'description': '',
    'city': 'Melle',
    'id': 3709,
    'blockId': 37,
    'queryName': 'brand rühr- und pumptechnik gmbh'
}], [4306, {
    'name': 'Brantner & Sohn',
    'description': '',
    'city': 'Laa/Thaya',
    'id': 4306,
    'blockId': 43,
    'queryName': 'brantner & sohn'
}], [8409, {
    'name': 'Braun',
    'description': '',
    'city': 'Feldkirchen-Westerham',
    'id': 8409,
    'blockId': 84,
    'queryName': 'braun'
}], [3734, {
    'name': 'Bremer Maschinenbau GmbH',
    'description': '',
    'city': 'Equord',
    'id': 3734,
    'blockId': 37,
    'queryName': 'bremer maschinenbau gmbh'
}], [4205, {
    'name': 'Bressel und Lade Maschinenbau',
    'description': '',
    'city': 'Visselhövede',
    'id': 4205,
    'blockId': 42,
    'queryName': 'bressel und lade maschinenbau'
}], [3705, {
    'name': 'Bridgestone Deutschland GmbH',
    'description': '',
    'city': 'Bad Homburg',
    'id': 3705,
    'blockId': 37,
    'queryName': 'bridgestone deutschland gmbh'
}], [3740, {
    'name': 'Briri GmbH',
    'description': '',
    'city': 'Bawinkel',
    'id': 3740,
    'blockId': 37,
    'queryName': 'briri gmbh'
}], [5206, {
    'name': 'Brunner GmbH',
    'description': '',
    'city': 'Eggenfelden',
    'id': 5206,
    'blockId': 52,
    'queryName': 'brunner gmbh'
}], [1507, {
    'name': 'Brunthaler Holzbau GmbH & co. KG',
    'description': '',
    'city': 'Egglham',
    'id': 1507,
    'blockId': 15,
    'queryName': 'brunthaler holzbau gmbh & co. kg'
}], [8502, {
    'name': 'BSA GmbH',
    'description': '',
    'city': 'Marktschorgast',
    'id': 8502,
    'blockId': 85,
    'queryName': 'bsa gmbh'
}], [1506, {
    'name': 'BTM-Fred Oliver Braunesberger',
    'description': '',
    'city': 'Strass im Attergau',
    'id': 1506,
    'blockId': 15,
    'queryName': 'btm-fred oliver braunesberger'
}], [1803, {
    'name': 'Buchner Vertriebs GmbH',
    'description': '',
    'city': 'Aholming',
    'id': 1803,
    'blockId': 18,
    'queryName': 'buchner vertriebs gmbh'
}], [3418, {
    'name': 'Büttner Agrartechnik',
    'description': '',
    'city': 'Unterschwaningen',
    'id': 3418,
    'blockId': 34,
    'queryName': 'büttner agrartechnik'
}], [1705, {
    'name': 'BZT-Design e.K.',
    'description': '',
    'city': 'Hengersberg',
    'id': 1705,
    'blockId': 17,
    'queryName': 'bzt-design e.k.'
}], [1505, {
    'name': 'C.A.R.M.E.N. e.V.',
    'description': '',
    'city': 'Straubing',
    'id': 1505,
    'blockId': 15,
    'queryName': 'c.a.r.m.e.n. e.v.'
}], [2502, {
    'name': 'Capello GmbH',
    'description': '',
    'city': 'Warstein',
    'id': 2502,
    'blockId': 25,
    'queryName': 'capello gmbh'
}], [2704, {
    'name': 'Celli SPA',
    'description': '',
    'city': 'Forli',
    'id': 2704,
    'blockId': 27,
    'queryName': 'celli spa'
}], [7513, {
    'name': 'Certis Belchim B.V. Niederlassung Deutschland',
    'description': '',
    'city': 'Hamburg',
    'id': 7513,
    'blockId': 75,
    'queryName': 'certis belchim b.v. niederlassung deutschland'
}], [4101, {
    'name': 'Claas Südostbayern GmbH',
    'description': '',
    'city': 'Töging a. Inn',
    'id': 4101,
    'blockId': 41,
    'queryName': 'claas südostbayern gmbh'
}], [3726, {
    'name': 'Dammann GmbH',
    'description': '',
    'city': 'Buxtehude',
    'id': 3726,
    'blockId': 37,
    'queryName': 'dammann gmbh'
}], [1111, {
    'name': 'Das Stemp **** Wellnessresort',
    'description': '',
    'city': 'Büchlberg',
    'id': 1111,
    'blockId': 11,
    'queryName': 'das stemp **** wellnessresort'
}], [3745, {
    'name': 'Dausch-Hallen GmbH',
    'description': '',
    'city': 'Markt Rettenbach',
    'id': 3745,
    'blockId': 37,
    'queryName': 'dausch-hallen gmbh'
}], [4211, {
    'name': 'Decker-Containerbau GmbH & Co. KG',
    'description': '',
    'city': 'St. Wolfgang',
    'id': 4211,
    'blockId': 42,
    'queryName': 'decker-containerbau gmbh & co. kg'
}], [7106, {
    'name': 'DeLaval GmbH',
    'description': '',
    'city': 'Glinde',
    'id': 7106,
    'blockId': 71,
    'queryName': 'delaval gmbh'
}], [3607, {
    'name': 'Demmler KG',
    'description': '',
    'city': 'Wertingen-Geratshofen',
    'id': 3607,
    'blockId': 36,
    'queryName': 'demmler kg'
}], [3423, {
    'name': 'DENKAVIT Futtermittel GmbH',
    'description': '',
    'city': 'Warendorf',
    'id': 3423,
    'blockId': 34,
    'queryName': 'denkavit futtermittel gmbh'
}], [2510, {
    'name': 'Deutsche Saatgut GmbH',
    'description': '',
    'city': 'Berlin',
    'id': 2510,
    'blockId': 25,
    'queryName': 'deutsche saatgut gmbh'
}], [1501, {
    'name': 'Deutscher Landwirtschaftsverlag GmbH',
    'description': '',
    'city': 'München',
    'id': 1501,
    'blockId': 15,
    'queryName': 'deutscher landwirtschaftsverlag gmbh'
}], [1128, {
    'name': 'Dichtungsprofi',
    'description': '',
    'city': 'Eferding/Fraham',
    'id': 1128,
    'blockId': 11,
    'queryName': 'dichtungsprofi'
}], [5904, {
    'name': 'Dick Maschinenverleih',
    'description': '',
    'city': 'Bad Griesbach',
    'id': 5904,
    'blockId': 59,
    'queryName': 'dick maschinenverleih'
}], [1408, {
    'name': 'DILA-Handel GmbH',
    'description': '',
    'city': 'Eberschwang 81',
    'id': 1408,
    'blockId': 14,
    'queryName': 'dila-handel gmbh'
}], [1228, {
    'name': 'Dirmeyer',
    'description': '',
    'city': 'Rinchnach',
    'id': 1228,
    'blockId': 12,
    'queryName': 'dirmeyer'
}], [4213, {
    'name': 'Dolberg GmbH & Co. KG',
    'description': '',
    'city': 'Altdorf',
    'id': 4213,
    'blockId': 42,
    'queryName': 'dolberg gmbh & co. kg'
}], [7406, {
    'name': 'Domo Caproleuna GmbH',
    'description': '',
    'city': 'Leuna',
    'id': 7406,
    'blockId': 74,
    'queryName': 'domo caproleuna gmbh'
}], [2403, {
    'name': 'Dorfladenbox GmbH',
    'description': '',
    'city': 'Weißkirchen a.d. Traun',
    'id': 2403,
    'blockId': 24,
    'queryName': 'dorfladenbox gmbh'
}], [2004, {
    'name': 'Dorn Landtechnik GmbH',
    'description': '',
    'city': 'Bruckberg',
    'id': 2004,
    'blockId': 20,
    'queryName': 'dorn landtechnik gmbh'
}], [2408, {
    'name': 'Dr. Knopf & Oswald GmbH',
    'description': '',
    'city': 'Aßling',
    'id': 2408,
    'blockId': 24,
    'queryName': 'dr. knopf & oswald gmbh'
}], [2001, {
    'name': 'Dragotech International  GmbH',
    'description': '',
    'city': 'Wurmannsquick',
    'id': 2001,
    'blockId': 20,
    'queryName': 'dragotech international  gmbh'
}], [7515, {
    'name': 'DSV - Deutsche Saatveredelung AG',
    'description': '',
    'city': 'Lippstadt',
    'id': 7515,
    'blockId': 75,
    'queryName': 'dsv - deutsche saatveredelung ag'
}], [7510, {
    'name': 'Düngekalk Gesellschaft mbH',
    'description': '',
    'city': 'Wörth',
    'id': 7510,
    'blockId': 75,
    'queryName': 'düngekalk gesellschaft mbh'
}], [4215, {
    'name': 'Düvelsdorf Handelsgesellschaft mbH',
    'description': '',
    'city': 'Ottersberg',
    'id': 4215,
    'blockId': 42,
    'queryName': 'düvelsdorf handelsgesellschaft mbh'
}], [7205, {
    'name': 'Duräumat Stalltechnik GmbH',
    'description': '',
    'city': 'Reinfeld',
    'id': 7205,
    'blockId': 72,
    'queryName': 'duräumat stalltechnik gmbh'
}], [1402, {
    'name': 'Dyna-Tech',
    'description': '',
    'city': 'Pöcking',
    'id': 1402,
    'blockId': 14,
    'queryName': 'dyna-tech'
}], [3608, {
    'name': 'Eck Landmaschinenbau',
    'description': '',
    'city': 'Brieskow-Finkenheerd',
    'id': 3608,
    'blockId': 36,
    'queryName': 'eck landmaschinenbau'
}], [2708, {
    'name': 'Eckart Maschinenbau GmbH',
    'description': '',
    'city': 'Schaufling',
    'id': 2708,
    'blockId': 27,
    'queryName': 'eckart maschinenbau gmbh'
}], [1905, {
    'name': 'Eder',
    'description': '',
    'city': 'Winzer',
    'id': 1905,
    'blockId': 19,
    'queryName': 'eder'
}], [3310, {
    'name': 'Eder GmbH',
    'description': '',
    'city': 'Tuntenhausen',
    'id': 3310,
    'blockId': 33,
    'queryName': 'eder gmbh'
}], [1804, {
    'name': 'Eder GmbH',
    'description': '',
    'city': 'Falkenberg',
    'id': 1804,
    'blockId': 18,
    'queryName': 'eder gmbh'
}], [3302, {
    'name': 'EDER GmbH',
    'description': '',
    'city': 'Tuntenhausen',
    'id': 3302,
    'blockId': 33,
    'queryName': 'eder gmbh'
}], [3301, {
    'name': 'Eder GmbH',
    'description': '',
    'city': 'Tuntenhausen',
    'id': 3301,
    'blockId': 33,
    'queryName': 'eder gmbh'
}], [3309, {
    'name': 'EDER GmbH',
    'description': '',
    'city': 'Tuntenhausen',
    'id': 3309,
    'blockId': 33,
    'queryName': 'eder gmbh'
}], [3604, {
    'name': 'Eder GmbH',
    'description': '',
    'city': 'Tuntenhausen',
    'id': 3604,
    'blockId': 36,
    'queryName': 'eder gmbh'
}], [3704, {
    'name': 'eFarmer B.V.',
    'description': '',
    'city': 'AS Amstelveen, Niederlande',
    'id': 3704,
    'blockId': 37,
    'queryName': 'efarmer b.v.'
}], [4203, {
    'name': 'EFKA-Tec Kamhuber e.K.',
    'description': '',
    'city': 'Erlbach',
    'id': 4203,
    'blockId': 42,
    'queryName': 'efka-tec kamhuber e.k.'
}], [3737, {
    'name': 'Eibelsgruber GdbR',
    'description': '',
    'city': 'Wurmsham',
    'id': 3737,
    'blockId': 37,
    'queryName': 'eibelsgruber gdbr'
}], [8104, {
    'name': 'Einböck GmbH',
    'description': '',
    'city': 'Dorf a.d. Pram',
    'id': 8104,
    'blockId': 81,
    'queryName': 'einböck gmbh'
}], [1325, {
    'name': 'Eisner-Nachbar',
    'description': '',
    'city': 'Haidmühle',
    'id': 1325,
    'blockId': 13,
    'queryName': 'eisner-nachbar'
}], [1320, {
    'name': 'Elektro Wichtrey GmbH',
    'description': '',
    'city': 'Merkendorf',
    'id': 1320,
    'blockId': 13,
    'queryName': 'elektro wichtrey gmbh'
}], [2414, {
    'name': 'EM Technologie Zentrum Süd GmbH',
    'description': '',
    'city': 'Wildpolsried',
    'id': 2414,
    'blockId': 24,
    'queryName': 'em technologie zentrum süd gmbh'
}], [1208, {
    'name': 'Energetix',
    'description': '',
    'city': 'Bad Griesbach',
    'id': 1208,
    'blockId': 12,
    'queryName': 'energetix'
}], [3741, {
    'name': 'energie PLUS agrar GmbH',
    'description': '',
    'city': 'Essingen',
    'id': 3741,
    'blockId': 37,
    'queryName': 'energie plus agrar gmbh'
}], [3701, {
    'name': 'Energiepark Hahnennest GmbH & Co. KG',
    'description': '',
    'city': 'Ostrach',
    'id': 3701,
    'blockId': 37,
    'queryName': 'energiepark hahnennest gmbh & co. kg'
}], [1511, {
    'name': 'ENERPIPE GmbH',
    'description': '',
    'city': 'Hilpolstein',
    'id': 1511,
    'blockId': 15,
    'queryName': 'enerpipe gmbh'
}], [5501, {
    'name': 'Engel',
    'description': '',
    'city': 'Stuhlingen-Lausheim',
    'id': 5501,
    'blockId': 55,
    'queryName': 'engel'
}], [3414, {
    'name': 'Erber AGRO GmbH',
    'description': '',
    'city': 'Sinabelkirchen',
    'id': 3414,
    'blockId': 34,
    'queryName': 'erber agro gmbh'
}], [1508, {
    'name': 'Erbersdobler',
    'description': '',
    'city': 'Fürstenzell',
    'id': 1508,
    'blockId': 15,
    'queryName': 'erbersdobler'
}], [2604, {
    'name': 'Erich Windschutzsystem GmbH',
    'description': '',
    'city': 'Ruhstorf',
    'id': 2604,
    'blockId': 26,
    'queryName': 'erich windschutzsystem gmbh'
}], [1125, {
    'name': 'Erndl Küchen GmbH',
    'description': '',
    'city': 'Osterhofen-Arbing',
    'id': 1125,
    'blockId': 11,
    'queryName': 'erndl küchen gmbh'
}], [1316, {
    'name': 'ERS Vertriebs GmbH',
    'description': '',
    'city': 'Golling a. d. Salzach',
    'id': 1316,
    'blockId': 13,
    'queryName': 'ers vertriebs gmbh'
}], [7103, {
    'name': 'Erzeugergemeinschaft Südbayern eG',
    'description': '',
    'city': 'Pocking',
    'id': 7103,
    'blockId': 71,
    'queryName': 'erzeugergemeinschaft südbayern eg'
}], [4304, {
    'name': 'Götz Landmaschinen GmbH',
    'description': '',
    'city': 'Schwabach-Wolkersdorf',
    'id': 4304,
    'blockId': 43,
    'queryName': 'götz landmaschinen gmbh'
}], [8704, {
    'name': 'Göweil Maschinenbau GmbH',
    'description': '',
    'city': 'Kirchschlag b. Linz',
    'id': 8704,
    'blockId': 87,
    'queryName': 'göweil maschinenbau gmbh'
}], [1318, {
    'name': 'golden Alpaca',
    'description': '',
    'city': 'Iggensbach',
    'id': 1318,
    'blockId': 13,
    'queryName': 'golden alpaca'
}], [3312, {
    'name': 'Graml',
    'description': '',
    'city': 'Kößlarn',
    'id': 3312,
    'blockId': 33,
    'queryName': 'graml'
}], [1202, {
    'name': 'Gratzl',
    'description': '',
    'city': 'Schöllnach',
    'id': 1202,
    'blockId': 12,
    'queryName': 'gratzl'
}], [3511, {
    'name': 'Green Energy',
    'description': '',
    'city': 'Mitterteich',
    'id': 3511,
    'blockId': 35,
    'queryName': 'green energy'
}], [1415, {
    'name': 'Griassdi.com',
    'description': '',
    'city': 'Söll',
    'id': 1415,
    'blockId': 14,
    'queryName': 'griassdi.com'
}], [5515, {
    'name': 'Griebl',
    'description': '',
    'city': 'Tettenweis',
    'id': 5515,
    'blockId': 55,
    'queryName': 'griebl'
}], [1807, {
    'name': 'Griebl',
    'description': '',
    'city': 'Haarbach',
    'id': 1807,
    'blockId': 18,
    'queryName': 'griebl'
}], [2707, {
    'name': 'Grimme Vertriebsgesellschaft mbH',
    'description': '',
    'city': 'Langquaid',
    'id': 2707,
    'blockId': 27,
    'queryName': 'grimme vertriebsgesellschaft mbh'
}], [3717, {
    'name': 'Gruber GmbH',
    'description': '',
    'city': 'Saalfelden am St. Meer',
    'id': 3717,
    'blockId': 37,
    'queryName': 'gruber gmbh'
}], [4401, {
    'name': 'Gruber KG',
    'description': '',
    'city': 'Ampfing',
    'id': 4401,
    'blockId': 44,
    'queryName': 'gruber kg'
}], [1210, {
    'name': 'gruber-maler',
    'description': '',
    'city': 'Pocking',
    'id': 1210,
    'blockId': 12,
    'queryName': 'gruber-maler'
}], [7605, {
    'name': 'Gruber-Maschinen GmbH',
    'description': '',
    'city': 'Gaspoltshofen',
    'id': 7605,
    'blockId': 76,
    'queryName': 'gruber-maschinen gmbh'
}], [2507, {
    'name': 'Grzybeck',
    'description': '',
    'city': 'Bad Füssing',
    'id': 2507,
    'blockId': 25,
    'queryName': 'grzybeck'
}], [3602, {
    'name': 'Güttler GmbH',
    'description': '',
    'city': 'Kirchhheim u. Teck',
    'id': 3602,
    'blockId': 36,
    'queryName': 'güttler gmbh'
}], [5510, {
    'name': 'Guntamatic Heiztechnik GmbH',
    'description': '',
    'city': 'Peuerbach',
    'id': 5510,
    'blockId': 55,
    'queryName': 'guntamatic heiztechnik gmbh'
}], [1701, {
    'name': 'Gut',
    'description': '',
    'city': 'Bad Griesbach i. Rottal',
    'id': 1701,
    'blockId': 17,
    'queryName': 'gut'
}], [3306, {
    'name': 'Gutswiller SAS',
    'description': '',
    'city': 'Lucelle',
    'id': 3306,
    'blockId': 33,
    'queryName': 'gutswiller sas'
}], [1411, {
    'name': 'Haaga Kehrmaschinen',
    'description': '',
    'city': 'Ergoldsbach',
    'id': 1411,
    'blockId': 14,
    'queryName': 'haaga kehrmaschinen'
}], [7203, {
    'name': 'Haas Fertigbau GmbH',
    'description': '',
    'city': 'Falkenberg',
    'id': 7203,
    'blockId': 72,
    'queryName': 'haas fertigbau gmbh'
}], [8801, {
    'name': 'Härtl GmbH',
    'description': '',
    'city': 'Rotthalmünster',
    'id': 8801,
    'blockId': 88,
    'queryName': 'härtl gmbh'
}], [1116, {
    'name': 'Haferbier',
    'description': '',
    'city': 'Syrgenstein',
    'id': 1116,
    'blockId': 11,
    'queryName': 'haferbier'
}], [1105, {
    'name': 'Haiber',
    'description': '',
    'city': 'Burladingen',
    'id': 1105,
    'blockId': 11,
    'queryName': 'haiber'
}], [3707, {
    'name': 'Hanslmeier',
    'description': '',
    'city': 'Reichertsheim',
    'id': 3707,
    'blockId': 37,
    'queryName': 'hanslmeier'
}], [4303, {
    'name': 'HARDI GmbH',
    'description': '',
    'city': 'Wedemark-Mellendorf',
    'id': 4303,
    'blockId': 43,
    'queryName': 'hardi gmbh'
}], [1212, {
    'name': 'Harecker',
    'description': '',
    'city': 'Forstinning',
    'id': 1212,
    'blockId': 12,
    'queryName': 'harecker'
}], [5203, {
    'name': 'Hargassner GesmbH',
    'description': '',
    'city': 'Weng i. Innkreis',
    'id': 5203,
    'blockId': 52,
    'queryName': 'hargassner gesmbh'
}], [3503, {
    'name': 'Hartl Landtechnik GmbH & Co. KG',
    'description': '',
    'city': 'Ortenburg',
    'id': 3503,
    'blockId': 35,
    'queryName': 'hartl landtechnik gmbh & co. kg'
}], [8608, {
    'name': 'Hartmann GmbH & Co. KG',
    'description': '',
    'city': 'Edelsfeld',
    'id': 8608,
    'blockId': 86,
    'queryName': 'hartmann gmbh & co. kg'
}], [3204, {
    'name': 'Hauer Frontlader GmbH',
    'description': '',
    'city': 'Malgersdorf',
    'id': 3204,
    'blockId': 32,
    'queryName': 'hauer frontlader gmbh'
}], [1107, {
    'name': 'Hauserbauer GmbH',
    'description': '',
    'city': 'Dorfgastein',
    'id': 1107,
    'blockId': 11,
    'queryName': 'hauserbauer gmbh'
}], [1219, {
    'name': 'Hausruckinger GbR',
    'description': '',
    'city': 'Pfarrkirchen',
    'id': 1219,
    'blockId': 12,
    'queryName': 'hausruckinger gbr'
}], [5105, {
    'name': 'HDG Bavaria GmbH',
    'description': '',
    'city': 'Massing',
    'id': 5105,
    'blockId': 51,
    'queryName': 'hdg bavaria gmbh'
}], [1401, {
    'name': 'Heim & Haus Vertriebgsgesellschaft für',
    'description': '',
    'city': 'Lauf/Pegnitz',
    'id': 1401,
    'blockId': 14,
    'queryName': 'heim & haus vertriebgsgesellschaft für'
}], [3508, {
    'name': 'Heitec Landtechnik-Vertriebs GmbH',
    'description': '',
    'city': 'Kirchdorf',
    'id': 3508,
    'blockId': 35,
    'queryName': 'heitec landtechnik-vertriebs gmbh'
}], [5104, {
    'name': 'Heizomat',
    'description': '',
    'city': 'Gunzenhausen',
    'id': 5104,
    'blockId': 51,
    'queryName': 'heizomat'
}], [1204, {
    'name': 'Helmberger',
    'description': '',
    'city': 'Kallmünz',
    'id': 1204,
    'blockId': 12,
    'queryName': 'helmberger'
}], [3421, {
    'name': 'Hema Fahrersitze',
    'description': '',
    'city': 'Pleinfeld',
    'id': 3421,
    'blockId': 34,
    'queryName': 'hema fahrersitze'
}], [2603, {
    'name': 'Henna Wast',
    'description': '',
    'city': 'Landshut',
    'id': 2603,
    'blockId': 26,
    'queryName': 'henna wast'
}], [5514, {
    'name': 'Herz Armaturen GmbH',
    'description': '',
    'city': 'Backnang',
    'id': 5514,
    'blockId': 55,
    'queryName': 'herz armaturen gmbh'
}], [7606, {
    'name': 'Hetwin Automation Systems GmbH',
    'description': '',
    'city': 'Langkampfen',
    'id': 7606,
    'blockId': 76,
    'queryName': 'hetwin automation systems gmbh'
}], [1124, {
    'name': 'Highländer Tracht',
    'description': '',
    'city': 'Windorf',
    'id': 1124,
    'blockId': 11,
    'queryName': 'highländer tracht'
}], [8803, {
    'name': 'Himel GmbH & Co. KG',
    'description': '',
    'city': 'Melchingen',
    'id': 8803,
    'blockId': 88,
    'queryName': 'himel gmbh & co. kg'
}], [7603, {
    'name': 'Hirl Misch- u. Anlagentechnik e.K.',
    'description': '',
    'city': 'Falkenberg',
    'id': 7603,
    'blockId': 76,
    'queryName': 'hirl misch- u. anlagentechnik e.k.'
}], [3101, {
    'name': 'HMG Hess GmbH & Co KG',
    'description': '',
    'city': 'Reisbach/Griesbach',
    'id': 3101,
    'blockId': 31,
    'queryName': 'hmg hess gmbh & co kg'
}], [8904, {
    'name': 'Hochgatterer e.U.',
    'description': '',
    'city': 'Pabneukirchen',
    'id': 8904,
    'blockId': 89,
    'queryName': 'hochgatterer e.u.'
}], [7604, {
    'name': 'Hörmann GmbH & Co KG',
    'description': '',
    'city': 'Buchloe',
    'id': 7604,
    'blockId': 76,
    'queryName': 'hörmann gmbh & co kg'
}], [8605, {
    'name': 'Horn GmbH 6 Co. KG',
    'description': '',
    'city': 'Bad Saulgau',
    'id': 8605,
    'blockId': 86,
    'queryName': 'horn gmbh 6 co. kg'
}], [2700, {
    'name': 'Huber',
    'description': '',
    'city': 'Tettenweis',
    'id': 2700,
    'blockId': 27,
    'queryName': 'huber'
}], [3715, {
    'name': 'Huber GmbH & Co. KG',
    'description': '',
    'city': 'Tittmoning',
    'id': 3715,
    'blockId': 37,
    'queryName': 'huber gmbh & co. kg'
}], [8906, {
    'name': 'Huemer',
    'description': '',
    'city': 'Gaspoldshofen',
    'id': 8906,
    'blockId': 89,
    'queryName': 'huemer'
}], [7403, {
    'name': 'Hüttinger',
    'description': '',
    'city': 'Pappenheim',
    'id': 7403,
    'blockId': 74,
    'queryName': 'hüttinger'
}], [1322, {
    'name': 'HWG Products GmbH',
    'description': '',
    'city': 'Wurmlingen',
    'id': 1322,
    'blockId': 13,
    'queryName': 'hwg products gmbh'
}], [3514, {
    'name': 'Hydrac Pühringer GmbH&CoKG',
    'description': '',
    'city': 'Neuzeug/Sierning',
    'id': 3514,
    'blockId': 35,
    'queryName': 'hydrac pühringer gmbh&cokg'
}], [1314, {
    'name': 'Hyla Handelsvertretung',
    'description': '',
    'city': 'Heldenstein',
    'id': 1314,
    'blockId': 13,
    'queryName': 'hyla handelsvertretung'
}], [8604, {
    'name': 'I.G. Pflanzenzucht GmbH',
    'description': '',
    'city': 'Ismaning',
    'id': 8604,
    'blockId': 86,
    'queryName': 'i.g. pflanzenzucht gmbh'
}], [2402, {
    'name': 'ICL europe B.V.',
    'description': '',
    'city': 'Ludwigshafen',
    'id': 2402,
    'blockId': 24,
    'queryName': 'icl europe b.v.'
}], [3308, {
    'name': 'Köckerling GmbH & Co KG',
    'description': '',
    'city': 'Verl',
    'id': 3308,
    'blockId': 33,
    'queryName': 'köckerling gmbh & co kg'
}], [8501, {
    'name': 'Köppl GmbH',
    'description': '',
    'city': 'Saldenburg',
    'id': 8501,
    'blockId': 85,
    'queryName': 'köppl gmbh'
}], [1405, {
    'name': 'Kotlarstvo Kralj',
    'description': '',
    'city': 'Slovenska Bistrica',
    'id': 1405,
    'blockId': 14,
    'queryName': 'kotlarstvo kralj'
}], [2609, {
    'name': 'Kotschenreuther',
    'description': '',
    'city': 'Steinwiesen',
    'id': 2609,
    'blockId': 26,
    'queryName': 'kotschenreuther'
}], [3710, {
    'name': 'Kotte Landtechnik GmbH & Co. KG',
    'description': '',
    'city': 'Rieste',
    'id': 3710,
    'blockId': 37,
    'queryName': 'kotte landtechnik gmbh & co. kg'
}], [8408, {
    'name': 'Kränzle GmbH & Co. KG',
    'description': '',
    'city': 'Illertissen',
    'id': 8408,
    'blockId': 84,
    'queryName': 'kränzle gmbh & co. kg'
}], [1808, {
    'name': 'Krampe',
    'description': '',
    'city': 'Coesfeld- Flamschen',
    'id': 1808,
    'blockId': 18,
    'queryName': 'krampe'
}], [2410, {
    'name': 'KRH Bleimbrunner GbR',
    'description': '',
    'city': 'Falkenberg',
    'id': 2410,
    'blockId': 24,
    'queryName': 'krh bleimbrunner gbr'
}], [4308, {
    'name': 'Kröger GmbH',
    'description': '',
    'city': 'Rechterfeld',
    'id': 4308,
    'blockId': 43,
    'queryName': 'kröger gmbh'
}], [2415, {
    'name': 'Kuhkomfort Allgäu',
    'description': '',
    'city': 'Görisried',
    'id': 2415,
    'blockId': 24,
    'queryName': 'kuhkomfort allgäu'
}], [4307, {
    'name': 'Kuhn Maschinenvertrieb GmbH',
    'description': '',
    'city': 'Gentin/Schopsdorf',
    'id': 4307,
    'blockId': 43,
    'queryName': 'kuhn maschinenvertrieb gmbh'
}], [4112, {
    'name': 'Kverneland Group Deutschland GmbH',
    'description': '',
    'city': 'Soest',
    'id': 4112,
    'blockId': 41,
    'queryName': 'kverneland group deutschland gmbh'
}], [5604, {
    'name': 'KWB Deutschland',
    'description': '',
    'city': 'Mertingen',
    'id': 5604,
    'blockId': 56,
    'queryName': 'kwb deutschland'
}], [7503, {
    'name': 'KWS Saat SE & Co. KgaA',
    'description': '',
    'city': 'Einbeck',
    'id': 7503,
    'blockId': 75,
    'queryName': 'kws saat se & co. kgaa'
}], [1409, {
    'name': 'Labertaler Heil- u. Mineralquellen',
    'description': '',
    'city': 'Schierling',
    'id': 1409,
    'blockId': 14,
    'queryName': 'labertaler heil- u. mineralquellen'
}], [1110, {
    'name': 'Ländliche Familienberatung',
    'description': '',
    'city': 'Passau',
    'id': 1110,
    'blockId': 11,
    'queryName': 'ländliche familienberatung'
}], [4305, {
    'name': 'Landgraf GmbH',
    'description': '',
    'city': 'Ostheim/Rhön',
    'id': 4305,
    'blockId': 43,
    'queryName': 'landgraf gmbh'
}], [4501, {
    'name': 'Landmedien Deutschland GmbH',
    'description': '',
    'city': 'Kempten',
    'id': 4501,
    'blockId': 45,
    'queryName': 'landmedien deutschland gmbh'
}], [7101, {
    'name': 'Landwirtschaftsverlag GmbH',
    'description': '',
    'city': 'Münster',
    'id': 7101,
    'blockId': 71,
    'queryName': 'landwirtschaftsverlag gmbh'
}], [4402, {
    'name': 'LTZ- Landtechnikzentren',
    'description': '',
    'city': 'Ampfing',
    'id': 4402,
    'blockId': 44,
    'queryName': 'ltz- landtechnikzentren'
}], [3725, {
    'name': 'Lugauer GmbH & Co. KG',
    'description': '',
    'city': 'Falkenstein',
    'id': 3725,
    'blockId': 37,
    'queryName': 'lugauer gmbh & co. kg'
}], [3202, {
    'name': 'MAMMUT',
    'description': '',
    'city': 'Gurten',
    'id': 3202,
    'blockId': 32,
    'queryName': 'mammut'
}], [8503, {
    'name': 'Marchner Maschinenbau GmbH',
    'description': '',
    'city': 'Winhöring',
    'id': 8503,
    'blockId': 85,
    'queryName': 'marchner maschinenbau gmbh'
}], [5505, {
    'name': 'Markmüller',
    'description': '',
    'city': 'Hofkirchen',
    'id': 5505,
    'blockId': 55,
    'queryName': 'markmüller'
}], [3721, {
    'name': 'Marmix GmbH & Co. KG',
    'description': '',
    'city': 'Unterwachingen',
    'id': 3721,
    'blockId': 37,
    'queryName': 'marmix gmbh & co. kg'
}], [1802, {
    'name': 'Marschallinger',
    'description': '',
    'city': 'Heimstetten',
    'id': 1802,
    'blockId': 18,
    'queryName': 'marschallinger'
}], [7411, {
    'name': 'MAS Seeds Deutschland GmbH',
    'description': '',
    'city': 'München',
    'id': 7411,
    'blockId': 74,
    'queryName': 'mas seeds deutschland gmbh'
}], [3708, {
    'name': 'Maschinen Schmidberger GmbH',
    'description': '',
    'city': 'Thierhaupten',
    'id': 3708,
    'blockId': 37,
    'queryName': 'maschinen schmidberger gmbh'
}], [3506, {
    'name': 'Maschinenfabrik Bermatingen GmbH & Co KG',
    'description': '',
    'city': 'Bermatingen',
    'id': 3506,
    'blockId': 35,
    'queryName': 'maschinenfabrik bermatingen gmbh & co kg'
}], [2106, {
    'name': 'MASCHIO-Deutschland GmbH',
    'description': '',
    'city': 'Thalmässing',
    'id': 2106,
    'blockId': 21,
    'queryName': 'maschio-deutschland gmbh'
}], [8606, {
    'name': 'MAT Motorland GmbH',
    'description': '',
    'city': 'Waldkraiburg',
    'id': 8606,
    'blockId': 86,
    'queryName': 'mat motorland gmbh'
}], [1224, {
    'name': 'Meddeb',
    'description': '',
    'city': 'Regenstauf',
    'id': 1224,
    'blockId': 12,
    'queryName': 'meddeb'
}], [1308, {
    'name': 'Mein Herzblut',
    'description': '',
    'city': 'Landau/Isar',
    'id': 1308,
    'blockId': 13,
    'queryName': 'mein herzblut'
}], [3729, {
    'name': 'Meixner Gülletechnik e.K.',
    'description': '',
    'city': 'Buchen Hollerbach',
    'id': 3729,
    'blockId': 37,
    'queryName': 'meixner gülletechnik e.k.'
}], [2501, {
    'name': 'Merlo Deutschland GmbH',
    'description': '',
    'city': 'Bremen',
    'id': 2501,
    'blockId': 25,
    'queryName': 'merlo deutschland gmbh'
}], [3711, {
    'name': 'Mezger Landtechnik GmbH & Co. KG',
    'description': '',
    'city': 'Ditzingen',
    'id': 3711,
    'blockId': 37,
    'queryName': 'mezger landtechnik gmbh & co. kg'
}], [3402, {
    'name': 'Michelin Reifenwerke AG & Co KGaA',
    'description': '',
    'city': 'Karlsruhe',
    'id': 3402,
    'blockId': 34,
    'queryName': 'michelin reifenwerke ag & co kgaa'
}], [8103, {
    'name': 'Milde GmbH',
    'description': '',
    'city': 'Gebenbach',
    'id': 8103,
    'blockId': 81,
    'queryName': 'milde gmbh'
}], [8405, {
    'name': 'Milkivit',
    'description': '',
    'city': 'Burgheim',
    'id': 8405,
    'blockId': 84,
    'queryName': 'milkivit'
}], [2607, {
    'name': 'Mitterbauer Stahlbau GmbH',
    'description': '',
    'city': 'Handenberg',
    'id': 2607,
    'blockId': 26,
    'queryName': 'mitterbauer stahlbau gmbh'
}], [3505, {
    'name': 'MLK-Vertriebs  GmbH',
    'description': '',
    'city': 'Arnstorf',
    'id': 3505,
    'blockId': 35,
    'queryName': 'mlk-vertriebs  gmbh'
}], [3407, {
    'name': 'MÖSCHA GbR',
    'description': '',
    'city': 'Oberroth',
    'id': 3407,
    'blockId': 34,
    'queryName': 'möscha gbr'
}], [1305, {
    'name': 'Morowe',
    'description': '',
    'city': 'Kempten',
    'id': 1305,
    'blockId': 13,
    'queryName': 'morowe'
}], [3412, {
    'name': 'Moser',
    'description': '',
    'city': 'Dietersburg',
    'id': 3412,
    'blockId': 34,
    'queryName': 'moser'
}], [1113, {
    'name': 'Moser',
    'description': '',
    'city': 'Bad Gögging',
    'id': 1113,
    'blockId': 11,
    'queryName': 'moser'
}], [1118, {
    'name': 'Moser GmbH',
    'description': '',
    'city': 'Wittibreut',
    'id': 1118,
    'blockId': 11,
    'queryName': 'moser gmbh'
}], [5401, {
    'name': 'MS Agrartechnik GmbH',
    'description': '',
    'city': 'Tiefenbach',
    'id': 5401,
    'blockId': 54,
    'queryName': 'ms agrartechnik gmbh'
}], [1311, {
    'name': 'Mühldorfer GmbH & Co KG',
    'description': '',
    'city': 'Haidmühle',
    'id': 1311,
    'blockId': 13,
    'queryName': 'mühldorfer gmbh & co kg'
}], [3102, {
    'name': 'Müller',
    'description': '',
    'city': 'Bad Birnbach',
    'id': 3102,
    'blockId': 31,
    'queryName': 'müller'
}], [8402, {
    'name': 'Müller GmbH',
    'description': '',
    'city': 'Weixerau',
    'id': 8402,
    'blockId': 84,
    'queryName': 'müller gmbh'
}], [8703, {
    'name': 'Müthing GmbH & Co KG',
    'description': '',
    'city': 'Neumarkt',
    'id': 8703,
    'blockId': 87,
    'queryName': 'müthing gmbh & co kg'
}], [1302, {
    'name': 'Multikraft',
    'description': '',
    'city': 'Pichl/Wels',
    'id': 1302,
    'blockId': 13,
    'queryName': 'multikraft'
}], [2506, {
    'name': 'Multikraft',
    'description': '',
    'city': 'Pichl/Wels',
    'id': 2506,
    'blockId': 25,
    'queryName': 'multikraft'
}], [1407, {
    'name': 'MusikVilla',
    'description': '',
    'city': 'Anzenkirchen',
    'id': 1407,
    'blockId': 14,
    'queryName': 'musikvilla'
}], [4405, {
    'name': 'MX Deutschland GmbH',
    'description': '',
    'city': 'Bonn',
    'id': 4405,
    'blockId': 44,
    'queryName': 'mx deutschland gmbh'
}], [1410, {
    'name': 'Nappa Lux Ldederwaren GmbH',
    'description': '',
    'city': 'Wesel',
    'id': 1410,
    'blockId': 14,
    'queryName': 'nappa lux ldederwaren gmbh'
}], [2405, {
    'name': 'Naturland Fachberatung',
    'description': '',
    'city': 'Hohenkammer',
    'id': 2405,
    'blockId': 24,
    'queryName': 'naturland fachberatung'
}], [2405, {
    'name': 'Natur-Saaten GmbH',
    'description': '',
    'city': 'Hofheim',
    'id': 2405,
    'blockId': 24,
    'queryName': 'natur-saaten gmbh'
}], [1327, {
    'name': 'NB Kontor GmbH',
    'description': '',
    'city': 'Hemer',
    'id': 1327,
    'blockId': 13,
    'queryName': 'nb kontor gmbh'
}], [1129, {
    'name': 'NB Kontor GmbH',
    'description': '',
    'city': 'Hemer',
    'id': 1129,
    'blockId': 11,
    'queryName': 'nb kontor gmbh'
}], [3205, {
    'name': 'Neff Landmaschinenpark GmbH',
    'description': '',
    'city': 'Neudrossenfeld',
    'id': 3205,
    'blockId': 32,
    'queryName': 'neff landmaschinenpark gmbh'
}], [3720, {
    'name': 'Netherlands Enterprise Agency (RVO)',
    'description': '',
    'city': 'Den Haag Niederlande',
    'id': 3720,
    'blockId': 37,
    'queryName': 'netherlands enterprise agency (rvo)'
}], [8609, {
    'name': 'Neuero Farm- u. Fördertechnik GmbH',
    'description': '',
    'city': 'Melle',
    'id': 8609,
    'blockId': 86,
    'queryName': 'neuero farm- u. fördertechnik gmbh'
}], [5510, {
    'name': 'Nothaft Neue Heizssteme',
    'description': '',
    'city': 'Hunding',
    'id': 5510,
    'blockId': 55,
    'queryName': 'nothaft neue heizssteme'
}], [1220, {
    'name': 'NudelneSterl',
    'description': '',
    'city': 'Bad Griesbach i. Rottal',
    'id': 1220,
    'blockId': 12,
    'queryName': 'nudelnesterl'
}], [8407, {
    'name': 'Obereder GmbH',
    'description': '',
    'city': 'Sigharting',
    'id': 8407,
    'blockId': 84,
    'queryName': 'obereder gmbh'
}], [3403, {
    'name': 'Oberleitner Windschutz GmbH & Co.KG',
    'description': '',
    'city': 'Tacherting',
    'id': 3403,
    'blockId': 34,
    'queryName': 'oberleitner windschutz gmbh & co.kg'
}], [3305, {
    'name': 'Oehler Maschinen',
    'description': '',
    'city': 'Offenburg',
    'id': 3305,
    'blockId': 33,
    'queryName': 'oehler maschinen'
}], [3744, {
    'name': 'OH Umwelttechnik GmbH',
    'description': '',
    'city': 'Aschau a. Inn',
    'id': 3744,
    'blockId': 37,
    'queryName': 'oh umwelttechnik gmbh'
}], [1207, {
    'name': 'Orthodorn',
    'description': '',
    'city': 'Rosenheim',
    'id': 1207,
    'blockId': 12,
    'queryName': 'orthodorn'
}], [1805, {
    'name': 'Orthodorn GmbH',
    'description': '',
    'city': 'Rosenheim',
    'id': 1805,
    'blockId': 18,
    'queryName': 'orthodorn gmbh'
}], [5901, {
    'name': 'Oswald',
    'description': '',
    'city': 'Regen',
    'id': 5901,
    'blockId': 59,
    'queryName': 'oswald'
}], [5503, {
    'name': 'Paintinger',
    'description': '',
    'city': 'Haibach',
    'id': 5503,
    'blockId': 55,
    'queryName': 'paintinger'
}], [1416, {
    'name': 'Pallhuber GmbH& Co KG',
    'description': '',
    'city': 'Langenlonsheim/Nahe',
    'id': 1416,
    'blockId': 14,
    'queryName': 'pallhuber gmbh& co kg'
}], [7410, {
    'name': 'PATURA KG',
    'description': '',
    'city': 'Laudenbach',
    'id': 7410,
    'blockId': 74,
    'queryName': 'patura kg'
}], [1902, {
    'name': 'Paul GmbH & Co. KG',
    'description': '',
    'city': 'Passau',
    'id': 1902,
    'blockId': 19,
    'queryName': 'paul gmbh & co. kg'
}], [1123, {
    'name': 'Pauli GmbH',
    'description': '',
    'city': 'Witzmannsberg Tittling',
    'id': 1123,
    'blockId': 11,
    'queryName': 'pauli gmbh'
}], [1206, {
    'name': 'Pellet Zentrum Egglham',
    'description': '',
    'city': 'Egglham',
    'id': 1206,
    'blockId': 12,
    'queryName': 'pellet zentrum egglham'
}], [5207, {
    'name': 'Perzl',
    'description': '',
    'city': 'Isen',
    'id': 5207,
    'blockId': 52,
    'queryName': 'perzl'
}], [4204, {
    'name': 'Profiagrartechnik e.K.',
    'description': '',
    'city': 'Donnersdorf',
    'id': 4204,
    'blockId': 42,
    'queryName': 'profiagrartechnik e.k.'
}], [5602, {
    'name': 'Profiforst GmbH',
    'description': '',
    'city': 'Esternberg',
    'id': 5602,
    'blockId': 56,
    'queryName': 'profiforst gmbh'
}], [3402, {
    'name': 'PTG Reifendrucksysteme GmbH',
    'description': '',
    'city': 'Neuss',
    'id': 3402,
    'blockId': 34,
    'queryName': 'ptg reifendrucksysteme gmbh'
}], [4206, {
    'name': 'Pühringer GmbH',
    'description': '',
    'city': 'Peuerbach',
    'id': 4206,
    'blockId': 42,
    'queryName': 'pühringer gmbh'
}], [7102, {
    'name': 'QUEBAG Bezugs und Absatz AG',
    'description': '',
    'city': 'Pocking',
    'id': 7102,
    'blockId': 71,
    'queryName': 'quebag bezugs und absatz ag'
}], [3404, {
    'name': 'Raiffeisenbank Neumarkt-St. Veith - Reischach e.G.',
    'description': '',
    'city': 'Wurmannsquick',
    'id': 3404,
    'blockId': 34,
    'queryName': 'raiffeisenbank neumarkt-st. veith - reischach e.g.'
}], [7104, {
    'name': 'Raiffeisen-Handels-GmbH',
    'description': '',
    'city': 'Rotthalmünster',
    'id': 7104,
    'blockId': 71,
    'queryName': 'raiffeisen-handels-gmbh'
}], [4207, {
    'name': 'Regent-Pflugfabrik GmbH',
    'description': '',
    'city': 'Attnang-Puchheim',
    'id': 4207,
    'blockId': 42,
    'queryName': 'regent-pflugfabrik gmbh'
}], [5707, {
    'name': 'Reil & Eichinger GmbH & Co. KG',
    'description': '',
    'city': 'Nittenau',
    'id': 5707,
    'blockId': 57,
    'queryName': 'reil & eichinger gmbh & co. kg'
}], [1420, {
    'name': 'Reinhardt',
    'description': '',
    'city': 'Rain/Lech',
    'id': 1420,
    'blockId': 14,
    'queryName': 'reinhardt'
}], [3509, {
    'name': 'Reisch GmbH',
    'description': '',
    'city': 'Ehekirchen-Hollenbach',
    'id': 3509,
    'blockId': 35,
    'queryName': 'reisch gmbh'
}], [1904, {
    'name': 'Rembart',
    'description': '',
    'city': 'Rotthalmünster',
    'id': 1904,
    'blockId': 19,
    'queryName': 'rembart'
}], [1226, {
    'name': 'Renofloor GmbH',
    'description': '',
    'city': 'Uettingen',
    'id': 1226,
    'blockId': 12,
    'queryName': 'renofloor gmbh'
}], [3602, {
    'name': 'Resch e.K.',
    'description': '',
    'city': 'Perkam',
    'id': 3602,
    'blockId': 36,
    'queryName': 'resch e.k.'
}], [3707, {
    'name': 'Ritter Landtechnik',
    'description': '',
    'city': 'Weißenhorn',
    'id': 3707,
    'blockId': 37,
    'queryName': 'ritter landtechnik'
}], [115, {
    'name': 'Robl Bauelemente',
    'description': '',
    'city': 'Ruhstorf/Sulzbach',
    'id': 115,
    'blockId': 11,
    'queryName': 'robl bauelemente'
}], [7505, {
    'name': 'Rösl GmbH & Co. KG',
    'description': '',
    'city': 'Regensburg',
    'id': 7505,
    'blockId': 75,
    'queryName': 'rösl gmbh & co. kg'
}], [3405, {
    'name': 'Rohn GmbH',
    'description': '',
    'city': 'Insingen',
    'id': 3405,
    'blockId': 34,
    'queryName': 'rohn gmbh'
}], [3409, {
    'name': 'Romberger',
    'description': '',
    'city': 'Anzenkirchen',
    'id': 3409,
    'blockId': 34,
    'queryName': 'romberger'
}], [5704, {
    'name': 'SERRA Maschinenbau GmbH',
    'description': '',
    'city': 'Rimsting',
    'id': 5704,
    'blockId': 57,
    'queryName': 'serra maschinenbau gmbh'
}], [7401, {
    'name': 'Siliconform Vertriebs GmbH & Co. KG',
    'description': '',
    'city': 'Türkheim/Allgäu',
    'id': 7401,
    'blockId': 74,
    'queryName': 'siliconform vertriebs gmbh & co. kg'
}], [8201, {
    'name': 'Siloking Mayer Maschinenbau GmbH',
    'description': '',
    'city': 'Tittmoning',
    'id': 8201,
    'blockId': 82,
    'queryName': 'siloking mayer maschinenbau gmbh'
}], [2104, {
    'name': 'Sinnhuber',
    'description': '',
    'city': 'Griesbach i. Rottal',
    'id': 2104,
    'blockId': 21,
    'queryName': 'sinnhuber'
}], [7508, {
    'name': 'SKW Stickstoffwerke Piesteritz GmbH',
    'description': '',
    'city': 'Lutherstadt Wittenberg',
    'id': 7508,
    'blockId': 75,
    'queryName': 'skw stickstoffwerke piesteritz gmbh'
}], [4506, {
    'name': 'Socken Sepp',
    'description': '',
    'city': 'Aham b. Landshut',
    'id': 4506,
    'blockId': 45,
    'queryName': 'socken sepp'
}], [1209, {
    'name': 'Softub Whirlpools',
    'description': '',
    'city': 'Postau',
    'id': 1209,
    'blockId': 12,
    'queryName': 'softub whirlpools'
}], [5601, {
    'name': 'Solarfocus GmbH',
    'description': '',
    'city': 'St. Ulrich b. Steyr',
    'id': 5601,
    'blockId': 56,
    'queryName': 'solarfocus gmbh'
}], [8406, {
    'name': 'Sonntag GmbH',
    'description': '',
    'city': 'Legau',
    'id': 8406,
    'blockId': 84,
    'queryName': 'sonntag gmbh'
}], [1104, {
    'name': 'Spröba GmbH',
    'description': '',
    'city': 'Neukirchen a. Inn',
    'id': 1104,
    'blockId': 11,
    'queryName': 'spröba gmbh'
}], [1903, {
    'name': 'Spuggal',
    'description': '',
    'city': 'Palling',
    'id': 1903,
    'blockId': 19,
    'queryName': 'spuggal'
}], [4208, {
    'name': 'Stallkamp ESTA GmbH',
    'description': '',
    'city': 'Dinklage',
    'id': 4208,
    'blockId': 42,
    'queryName': 'stallkamp esta gmbh'
}], [8203, {
    'name': 'Stallprofi',
    'description': '',
    'city': 'Gunskirchen',
    'id': 8203,
    'blockId': 82,
    'queryName': 'stallprofi'
}], [1101, {
    'name': 'Steam Deutschland GmbH',
    'description': '',
    'city': 'Gerabronn',
    'id': 1101,
    'blockId': 11,
    'queryName': 'steam deutschland gmbh'
}], [2504, {
    'name': 'Steiner Automation GmbHCo.KG',
    'description': '',
    'city': 'Hochburg-Ach',
    'id': 2504,
    'blockId': 25,
    'queryName': 'steiner automation gmbhco.kg'
}], [1901, {
    'name': 'Steiner Deutschland GmbH',
    'description': '',
    'city': 'Landau a.d.Isar',
    'id': 1901,
    'blockId': 19,
    'queryName': 'steiner deutschland gmbh'
}], [3103, {
    'name': 'Stockmann',
    'description': '',
    'city': 'Erharting',
    'id': 3103,
    'blockId': 31,
    'queryName': 'stockmann'
}], [8504, {
    'name': 'Stoll Maschinenfabrik GmbH',
    'description': '',
    'city': 'Lengede',
    'id': 8504,
    'blockId': 85,
    'queryName': 'stoll maschinenfabrik gmbh'
}], [4216, {
    'name': 'Strautmann & Söhne GmbH & Co. KG',
    'description': '',
    'city': 'Bad Laer',
    'id': 4216,
    'blockId': 42,
    'queryName': 'strautmann & söhne gmbh & co. kg'
}], [3306, {
    'name': 'Streumaster',
    'description': '',
    'city': 'Egglkofen',
    'id': 3306,
    'blockId': 33,
    'queryName': 'streumaster'
}], [4407, {
    'name': 'Südbayerische Landtechnik GmbH',
    'description': '',
    'city': 'Antdorf',
    'id': 4407,
    'blockId': 44,
    'queryName': 'südbayerische landtechnik gmbh'
}], [7201, {
    'name': 'Suevia Haiges GmbH',
    'description': '',
    'city': 'Kirchheim/Nekar',
    'id': 7201,
    'blockId': 72,
    'queryName': 'suevia haiges gmbh'
}], [3727, {
    'name': 'SUMA Rührtechnik GmbH',
    'description': '',
    'city': 'Sulzberg',
    'id': 3727,
    'blockId': 37,
    'queryName': 'suma rührtechnik gmbh'
}], [3739, {
    'name': 'SYN TRAC GmbH',
    'description': '',
    'city': 'Bad Goisern',
    'id': 3739,
    'blockId': 37,
    'queryName': 'syn trac gmbh'
}], [7404, {
    'name': 'Syngenta Agro GmbH',
    'description': '',
    'city': 'Frankfurt a. Main',
    'id': 7404,
    'blockId': 74,
    'queryName': 'syngenta agro gmbh'
}], [2508, {
    'name': 'System Happel GmbH',
    'description': '',
    'city': 'Friesenried',
    'id': 2508,
    'blockId': 25,
    'queryName': 'system happel gmbh'
}], [5509, {
    'name': 'TCR Reinigungsechnik',
    'description': '',
    'city': 'Michelfeld',
    'id': 5509,
    'blockId': 55,
    'queryName': 'tcr reinigungsechnik'
}], [1307, {
    'name': 'Team Gruber GmbH',
    'description': '',
    'city': 'Steinrkirchen Österreich',
    'id': 1307,
    'blockId': 13,
    'queryName': 'team gruber gmbh'
}], [5508, {
    'name': 'Technolit GmbH',
    'description': '',
    'city': 'Großenlüder',
    'id': 5508,
    'blockId': 55,
    'queryName': 'technolit gmbh'
}], [1707, {
    'name': 'TeFerro Holzbackofen',
    'description': '',
    'city': 'Gerolsbach',
    'id': 1707,
    'blockId': 17,
    'queryName': 'teferro holzbackofen'
}], [4108, {
    'name': 'Tehnos d.o.o.',
    'description': '',
    'city': 'Zalec',
    'id': 4108,
    'blockId': 41,
    'queryName': 'tehnos d.o.o.'
}], [2413, {
    'name': 'Terra Care GmbH',
    'description': '',
    'city': 'Neukirchen/Vöckla',
    'id': 2413,
    'blockId': 24,
    'queryName': 'terra care gmbh'
}], [1121, {
    'name': 'Terra Plus',
    'description': '',
    'city': 'Nüdlingen',
    'id': 1121,
    'blockId': 11,
    'queryName': 'terra plus'
}], [2404, {
    'name': 'Texas Trading GmbH',
    'description': '',
    'city': 'Windach',
    'id': 2404,
    'blockId': 24,
    'queryName': 'texas trading gmbh'
}], [3512, {
    'name': 'Thaler GmbH & Co. KG',
    'description': '',
    'city': 'Polling',
    'id': 3512,
    'blockId': 35,
    'queryName': 'thaler gmbh & co. kg'
}], [1117, {
    'name': 'Thermomix Handelsvertretung',
    'description': '',
    'city': 'Pocking',
    'id': 1117,
    'blockId': 11,
    'queryName': 'thermomix handelsvertretung'
}], [8903, {
    'name': 'Traunsteiner Vertriebs GmbH',
    'description': '',
    'city': 'Maitenbeth',
    'id': 8903,
    'blockId': 89,
    'queryName': 'traunsteiner vertriebs gmbh'
}], [2608, {
    'name': 'Treffler Maschinenbau GmbH & Co. KG',
    'description': '',
    'city': 'Echsheim',
    'id': 2608,
    'blockId': 26,
    'queryName': 'treffler maschinenbau gmbh & co. kg'
}], [3712, {
    'name': 'Trelleborg Wheel Systems Germany GmbH',
    'description': '',
    'city': 'Erbach/Odenw.',
    'id': 3712,
    'blockId': 37,
    'queryName': 'trelleborg wheel systems germany gmbh'
}], [8404, {
    'name': 'Trioliet BV',
    'description': '',
    'city': 'BW Oldenzaal',
    'id': 8404,
    'blockId': 84,
    'queryName': 'trioliet bv'
}], [3609, {
    'name': 'TRUMAG',
    'description': '',
    'city': 'Wildenau',
    'id': 3609,
    'blockId': 36,
    'queryName': 'trumag'
}], [2606, {
    'name': 'Tuchel Maschinenbau GmbH',
    'description': '',
    'city': 'Salzbergen',
    'id': 2606,
    'blockId': 26,
    'queryName': 'tuchel maschinenbau gmbh'
}], [3408, {
    'name': 'Uhrle GmbH & Co KG',
    'description': '',
    'city': 'Ellwangen-Röhlingen',
    'id': 3408,
    'blockId': 34,
    'queryName': 'uhrle gmbh & co kg'
}], [5204, {
    'name': 'Unterreiner',
    'description': '',
    'city': 'Julbach/Buch',
    'id': 5204,
    'blockId': 52,
    'queryName': 'unterreiner'
}], [3504, {
    'name': 'Urban Landmaschinen GmbH',
    'description': '',
    'city': 'Essenbach-Oberahrain',
    'id': 3504,
    'blockId': 35,
    'queryName': 'urban landmaschinen gmbh'
}], [4302, {
    'name': 'Väderstad GmbH',
    'description': '',
    'city': 'Werder/Havel',
    'id': 4302,
    'blockId': 43,
    'queryName': 'väderstad gmbh'
}], [2406, {
    'name': 'van Lengerich',
    'description': '',
    'city': 'Emsbüren',
    'id': 2406,
    'blockId': 24,
    'queryName': 'van lengerich'
}], [1108, {
    'name': 'Veras Nähstüberl',
    'description': '',
    'city': 'Pocking',
    'id': 1108,
    'blockId': 11,
    'queryName': 'veras nähstüberl'
}], [2416, {
    'name': 'Vermarktungsgesellschaft Bio-Bauern mbH',
    'description': '',
    'city': 'Pöttmes',
    'id': 2416,
    'blockId': 24,
    'queryName': 'vermarktungsgesellschaft bio-bauern mbh'
}], [8401, {
    'name': 'Vetro-Star GmbH',
    'description': '',
    'city': 'Burtenbach',
    'id': 8401,
    'blockId': 84,
    'queryName': 'vetro-star gmbh'
}], [1323, {
    'name': 'Vettermann',
    'description': '',
    'city': 'Hainsacker',
    'id': 1323,
    'blockId': 13,
    'queryName': 'vettermann'
}], [1317, {
    'name': 'VI-JA d.o.o.',
    'description': '',
    'city': 'Zalec Slowenien',
    'id': 1317,
    'blockId': 13,
    'queryName': 'vi-ja d.o.o.'
}], [1326, {
    'name': 'Vilsmeier',
    'description': '',
    'city': 'Kröning',
    'id': 1326,
    'blockId': 13,
    'queryName': 'vilsmeier'
}], [3716, {
    'name': 'Vogelsang GmbH & Co. KG',
    'description': '',
    'city': 'Essen',
    'id': 3716,
    'blockId': 37,
    'queryName': 'vogelsang gmbh & co. kg'
}], [1512, {
    'name': 'Vogelsang Service Süd GmbH',
    'description': '',
    'city': 'Ruhstorf a. d. Rott',
    'id': 1512,
    'blockId': 15,
    'queryName': 'vogelsang service süd gmbh'
}], [5302, {
    'name': 'VOGT GmbH & Co.KG',
    'description': '',
    'city': 'Schmallenberg',
    'id': 5302,
    'blockId': 53,
    'queryName': 'vogt gmbh & co.kg'
}], [3723, {
    'name': 'Voran Maschinen GmbH',
    'description': '',
    'city': 'Pichl/Wels',
    'id': 3723,
    'blockId': 37,
    'queryName': 'voran maschinen gmbh'
}], [1103, {
    'name': 'Vorwerk Deutschland Stiftung &CoKG',
    'description': '',
    'city': 'Deggendorf',
    'id': 1103,
    'blockId': 11,
    'queryName': 'vorwerk deutschland stiftung &cokg'
}], [4502, {
    'name': 'VUXXX GmbH',
    'description': '',
    'city': 'Papenburg',
    'id': 4502,
    'blockId': 45,
    'queryName': 'vuxxx gmbh'
}], [3711, {
    'name': 'Wagener Hydraulikteile GmbH',
    'description': '',
    'city': 'Hattingen',
    'id': 3711,
    'blockId': 37,
    'queryName': 'wagener hydraulikteile gmbh'
}], [5516, {
    'name': 'Wald21 GmbH',
    'description': '',
    'city': 'Uffenheim',
    'id': 5516,
    'blockId': 55,
    'queryName': 'wald21 gmbh'
}], [3208, {
    'name': 'Wallner',
    'description': '',
    'city': 'Roßbach',
    'id': 3208,
    'blockId': 32,
    'queryName': 'wallner'
}], [3406, {
    'name': 'Wallner',
    'description': '',
    'city': 'Traunreut/Matzing',
    'id': 3406,
    'blockId': 34,
    'queryName': 'wallner'
}], [7306, {
    'name': 'Wasserbauer Ges.m.b.H.',
    'description': '',
    'city': 'Waldneukirchen',
    'id': 7306,
    'blockId': 73,
    'queryName': 'wasserbauer ges.m.b.h.'
}], [1504, {
    'name': 'WEFA Dach- und Steinreinigungssysteme',
    'description': '',
    'city': 'Fichtenau',
    'id': 1504,
    'blockId': 15,
    'queryName': 'wefa dach- und steinreinigungssysteme'
}], [1329, {
    'name': 'WEHA Wassertechnik',
    'description': '',
    'city': 'Elztal',
    'id': 1329,
    'blockId': 13,
    'queryName': 'weha wassertechnik'
}], [3208, {
    'name': 'Weinhäupl GmbH',
    'description': '',
    'city': 'Uttendorf',
    'id': 3208,
    'blockId': 32,
    'queryName': 'weinhäupl gmbh'
}], [3507, {
    'name': 'Weinzierl',
    'description': '',
    'city': 'Wernberg-Köblitz',
    'id': 3507,
    'blockId': 35,
    'queryName': 'weinzierl'
}], [4509, {
    'name': 'Weissl GmbH',
    'description': '',
    'city': 'Engelsberg Obb.',
    'id': 4509,
    'blockId': 45,
    'queryName': 'weissl gmbh'
}], [3732, {
    'name': 'Wematik GmbH',
    'description': '',
    'city': 'Nordhorn',
    'id': 3732,
    'blockId': 37,
    'queryName': 'wematik gmbh'
}], [5506, {
    'name': 'Wenk KG',
    'description': '',
    'city': 'Reisbach',
    'id': 5506,
    'blockId': 55,
    'queryName': 'wenk kg'
}], [2601, {
    'name': 'Westtech Maschinenbau GmbH',
    'description': '',
    'city': 'Prambachkirchen',
    'id': 2601,
    'blockId': 26,
    'queryName': 'westtech maschinenbau gmbh'
}], [1223, {
    'name': 'Wiltschka',
    'description': '',
    'city': 'Elchingen',
    'id': 1223,
    'blockId': 12,
    'queryName': 'wiltschka'
}], [1419, {
    'name': 'Wiltschka',
    'description': '',
    'city': 'Elchingen',
    'id': 1419,
    'blockId': 14,
    'queryName': 'wiltschka'
}], [8701, {
    'name': 'Wimmer',
    'description': '',
    'city': 'Gangkofen',
    'id': 8701,
    'blockId': 87,
    'queryName': 'wimmer'
}], [1406, {
    'name': 'Windler',
    'description': '',
    'city': 'Wildbach/Erzgeb.',
    'id': 1406,
    'blockId': 14,
    'queryName': 'windler'
}], [8702, {
    'name': 'Winkler Fahrzeugteile GmbH',
    'description': '',
    'city': 'Deggendorf',
    'id': 8702,
    'blockId': 87,
    'queryName': 'winkler fahrzeugteile gmbh'
}], [8804, {
    'name': 'Wölfleder GmbH',
    'description': '',
    'city': 'Sigharting Oö',
    'id': 8804,
    'blockId': 88,
    'queryName': 'wölfleder gmbh'
}], [2003, {
    'name': 'Wohlmannstetter Landtechnik',
    'description': '',
    'city': 'Unterdietfurt',
    'id': 2003,
    'blockId': 20,
    'queryName': 'wohlmannstetter landtechnik'
}], [7607, {
    'name': 'Wolf System GmbH',
    'description': '',
    'city': 'Osterhofen',
    'id': 7607,
    'blockId': 76,
    'queryName': 'wolf system gmbh'
}], [5502, {
    'name': 'Woodland Mills Deutschland',
    'description': '',
    'city': 'Haibach-Elisabethszell',
    'id': 5502,
    'blockId': 55,
    'queryName': 'woodland mills deutschland'
}], [1417, {
    'name': 'XXXLutz',
    'description': '',
    'city': 'Passau',
    'id': 1417,
    'blockId': 14,
    'queryName': 'xxxlutz'
}], [7407, {
    'name': 'Yara GmbH & Co. KG',
    'description': '',
    'city': 'Dülmen',
    'id': 7407,
    'blockId': 74,
    'queryName': 'yara gmbh & co. kg'
}], [1328, {
    'name': 'ZellAktiv GmbH',
    'description': '',
    'city': 'Rinchnach',
    'id': 1328,
    'blockId': 13,
    'queryName': 'zellaktiv gmbh'
}], [1114, {
    'name': 'ZellAktiv GmbH',
    'description': '',
    'city': 'Rinchnach',
    'id': 1114,
    'blockId': 11,
    'queryName': 'zellaktiv gmbh'
}], [8102, {
    'name': 'Zenz Landtechnik GmbH',
    'description': '',
    'city': 'Gars/Inn',
    'id': 8102,
    'blockId': 81,
    'queryName': 'zenz landtechnik gmbh'
}], [1404, {
    'name': 'Zettner',
    'description': '',
    'city': 'Lonnerstadt',
    'id': 1404,
    'blockId': 14,
    'queryName': 'zettner'
}], [2705, {
    'name': 'Ziegler GmbH',
    'description': '',
    'city': 'Pöttmes',
    'id': 2705,
    'blockId': 27,
    'queryName': 'ziegler gmbh'
}], [2605, {
    'name': 'Zieglmeier Hydraulik e.K.',
    'description': '',
    'city': 'Rottenburg a d. Laaber',
    'id': 2605,
    'blockId': 26,
    'queryName': 'zieglmeier hydraulik e.k.'
}], [8705, {
    'name': 'Zillinger',
    'description': '',
    'city': 'Passau',
    'id': 8705,
    'blockId': 87,
    'queryName': 'zillinger'
}], [1122, {
    'name': 'Zöls',
    'description': '',
    'city': 'Fürstenzell',
    'id': 1122,
    'blockId': 11,
    'queryName': 'zöls'
}], [1127, {
    'name': 'Zorn',
    'description': '',
    'city': 'Furth b. Göttweig',
    'id': 1127,
    'blockId': 11,
    'queryName': 'zorn'
}], [4212, {
    'name': 'Zürn Harvesting GmbH & Co. KG',
    'description': '',
    'city': 'Ravenstein-Merchingen',
    'id': 4212,
    'blockId': 42,
    'queryName': 'zürn harvesting gmbh & co. kg'
}], [3601, {
    'name': 'Zunhammer GmbH',
    'description': '',
    'city': 'Matzing/Traunreut',
    'id': 3601,
    'blockId': 36,
    'queryName': 'zunhammer gmbh'
}], [2007, {
    'name': 'Zuwa - Zumpe GmbH',
    'description': '',
    'city': 'Laufen',
    'id': 2007,
    'blockId': 20,
    'queryName': 'zuwa - zumpe gmbh'
}], [1712, {
    'name': 'Zweirad Würdinger',
    'description': '',
    'city': 'Vilshofen',
    'id': 1712,
    'blockId': 17,
    'queryName': 'zweirad würdinger'
}], [5106, {
    'name': 'Eschlböck GmbH',
    'description': '',
    'city': 'Simbach a. Inn',
    'id': 5106,
    'blockId': 51,
    'queryName': 'eschlböck gmbh'
}], [1106, {
    'name': 'ESW Wohndesign',
    'description': '',
    'city': 'Obermauerbach',
    'id': 1106,
    'blockId': 11,
    'queryName': 'esw wohndesign'
}], [5603, {
    'name': 'ETA-Heiztechnik GmbH',
    'description': '',
    'city': 'Hofkirchen/Trattnach',
    'id': 5603,
    'blockId': 56,
    'queryName': 'eta-heiztechnik gmbh'
}], [4403, {
    'name': 'ETZ Hellmuth GmbH & Co KG',
    'description': '',
    'city': 'Treuchtlingen',
    'id': 4403,
    'blockId': 44,
    'queryName': 'etz hellmuth gmbh & co kg'
}], [1708, {
    'name': 'Eurobalkone & Zäune',
    'description': '',
    'city': 'Böhmfeld',
    'id': 1708,
    'blockId': 17,
    'queryName': 'eurobalkone & zäune'
}], [1126, {
    'name': 'EuroCom GmbH',
    'description': '',
    'city': 'Pforzheim',
    'id': 1126,
    'blockId': 11,
    'queryName': 'eurocom gmbh'
}], [2702, {
    'name': 'EVZ-Agrarsysteme GmbH',
    'description': '',
    'city': 'Ebersberg',
    'id': 2702,
    'blockId': 27,
    'queryName': 'evz-agrarsysteme gmbh'
}], [1203, {
    'name': 'Exclusives Wohnen',
    'description': '',
    'city': 'Landshut',
    'id': 1203,
    'blockId': 12,
    'queryName': 'exclusives wohnen'
}], [7507, {
    'name': 'Ezinger GmbH',
    'description': '',
    'city': 'Neuhaus',
    'id': 7507,
    'blockId': 75,
    'queryName': 'ezinger gmbh'
}], [2005, {
    'name': 'Faltner GmbH',
    'description': '',
    'city': 'Büchlberg',
    'id': 2005,
    'blockId': 20,
    'queryName': 'faltner gmbh'
}], [8502, {
    'name': 'FAN Separator GmbH',
    'description': '',
    'city': 'Marktschorgast',
    'id': 8502,
    'blockId': 85,
    'queryName': 'fan separator gmbh'
}], [4210, {
    'name': 'Faresin Deutschland GmbH',
    'description': '',
    'city': 'Gallmersgarten',
    'id': 4210,
    'blockId': 42,
    'queryName': 'faresin deutschland gmbh'
}], [8301, {
    'name': 'farmtec A.L.T.',
    'description': '',
    'city': 'Altheim bei Essenbach',
    'id': 8301,
    'blockId': 83,
    'queryName': 'farmtec a.l.t.'
}], [3304, {
    'name': 'Fedlmeier GmbH',
    'description': '',
    'city': 'Geisenhausen',
    'id': 3304,
    'blockId': 33,
    'queryName': 'fedlmeier gmbh'
}], [7601, {
    'name': 'Feuchtgruber GmbH',
    'description': '',
    'city': 'Wurmansquick',
    'id': 7601,
    'blockId': 76,
    'queryName': 'feuchtgruber gmbh'
}], [8204, {
    'name': 'Fierthbauer GmbH',
    'description': '',
    'city': 'Regensburg',
    'id': 8204,
    'blockId': 82,
    'queryName': 'fierthbauer gmbh'
}], [7405, {
    'name': 'Fink',
    'description': '',
    'city': 'Falkenstein',
    'id': 7405,
    'blockId': 74,
    'queryName': 'fink'
}], [7602, {
    'name': 'Fischer',
    'description': '',
    'city': 'Bad Griesbach',
    'id': 7602,
    'blockId': 76,
    'queryName': 'fischer'
}], [3502, {
    'name': 'Fliegl',
    'description': '',
    'city': 'Kirchdorf',
    'id': 3502,
    'blockId': 35,
    'queryName': 'fliegl'
}], [3501, {
    'name': 'Fliegl',
    'description': '',
    'city': 'Mühldorf',
    'id': 3501,
    'blockId': 35,
    'queryName': 'fliegl'
}], [5903, {
    'name': 'Fritz Heizsysteme',
    'description': '',
    'city': 'Braunau',
    'id': 5903,
    'blockId': 59,
    'queryName': 'fritz heizsysteme'
}], [5202, {
    'name': 'Fröling',
    'description': '',
    'city': 'Grieskirchen',
    'id': 5202,
    'blockId': 52,
    'queryName': 'fröling'
}], [1306, {
    'name': 'Gabriel',
    'description': '',
    'city': 'Neuhaus/Inn',
    'id': 1306,
    'blockId': 13,
    'queryName': 'gabriel'
}], [5517, {
    'name': 'Gadermair',
    'description': '',
    'city': 'Mining',
    'id': 5517,
    'blockId': 55,
    'queryName': 'gadermair'
}], [4110, {
    'name': 'Gassner Technik GbR',
    'description': '',
    'city': 'Aying',
    'id': 4110,
    'blockId': 41,
    'queryName': 'gassner technik gbr'
}], [7105, {
    'name': 'GEA Farm Technologies GmbH',
    'description': '',
    'city': 'Bönen',
    'id': 7105,
    'blockId': 71,
    'queryName': 'gea farm technologies gmbh'
}], [1218, {
    'name': 'Gebhard',
    'description': '',
    'city': 'Frontenhauseen',
    'id': 1218,
    'blockId': 12,
    'queryName': 'gebhard'
}], [3735, {
    'name': 'Gebrüder Peiffer GmbH & Co. KG',
    'description': '',
    'city': 'Grevenbroich',
    'id': 3735,
    'blockId': 37,
    'queryName': 'gebrüder peiffer gmbh & co. kg'
}], [1510, {
    'name': 'Geisberger',
    'description': '',
    'city': 'Schwindegg',
    'id': 1510,
    'blockId': 15,
    'queryName': 'geisberger'
}], [7307, {
    'name': 'Geiß',
    'description': '',
    'city': 'Dietmannsried-Reicholzr.',
    'id': 7307,
    'blockId': 73,
    'queryName': 'geiß'
}], [3203, {
    'name': 'Gerbl Maschinenbau GmbH',
    'description': '',
    'city': 'Wurmsham',
    'id': 3203,
    'blockId': 32,
    'queryName': 'gerbl maschinenbau gmbh'
}], [1216, {
    'name': 'Gerhardt GmbH & Co. KG',
    'description': '',
    'city': 'Dexheim',
    'id': 1216,
    'blockId': 12,
    'queryName': 'gerhardt gmbh & co. kg'
}], [1310, {
    'name': 'Gerhardt Wein & Sekt GmbH',
    'description': '',
    'city': 'Bornheim',
    'id': 1310,
    'blockId': 13,
    'queryName': 'gerhardt wein & sekt gmbh'
}], [5507, {
    'name': 'Germoto',
    'description': '',
    'city': 'Wittibreut',
    'id': 5507,
    'blockId': 55,
    'queryName': 'germoto'
}], [3703, {
    'name': 'Gesma GmbH',
    'description': '',
    'city': 'Schlüsslberg',
    'id': 3703,
    'blockId': 37,
    'queryName': 'gesma gmbh'
}], [4201, {
    'name': 'Göttl GmbH',
    'description': '',
    'city': 'Bayerbach',
    'id': 4201,
    'blockId': 42,
    'queryName': 'göttl gmbh'
}], [1509, {
    'name': 'Göttler',
    'description': '',
    'city': 'Hohenaltheim',
    'id': 1509,
    'blockId': 15,
    'queryName': 'göttler'
}], [7304, {
    'name': 'Göttsberger GmbH',
    'description': '',
    'city': 'Babensham',
    'id': 7304,
    'blockId': 73,
    'queryName': 'göttsberger gmbh'
}], [5518, {
    'name': 'Isaak Haustechnik GmbH',
    'description': '',
    'city': 'Tettenweis',
    'id': 5518,
    'blockId': 55,
    'queryName': 'isaak haustechnik gmbh'
}], [8901, {
    'name': 'Janetschek GmbH',
    'description': '',
    'city': 'Pocking',
    'id': 8901,
    'blockId': 89,
    'queryName': 'janetschek gmbh'
}], [5512, {
    'name': 'jb-concept GmbH',
    'description': '',
    'city': 'Eggenfelden',
    'id': 5512,
    'blockId': 55,
    'queryName': 'jb-concept gmbh'
}], [1109, {
    'name': 'Jetzlsperger',
    'description': '',
    'city': 'Petting',
    'id': 1109,
    'blockId': 11,
    'queryName': 'jetzlsperger'
}], [4406, {
    'name': 'Joskin S.A.',
    'description': '',
    'city': 'Soumagne',
    'id': 4406,
    'blockId': 44,
    'queryName': 'joskin s.a.'
}], [7412, {
    'name': 'K + S Minerals and Agriculture GmbH',
    'description': '',
    'city': 'Kassel',
    'id': 7412,
    'blockId': 74,
    'queryName': 'k + s minerals and agriculture gmbh'
}], [5403, {
    'name': 'k&k solar GmbH',
    'description': '',
    'city': 'Deggendorf',
    'id': 5403,
    'blockId': 54,
    'queryName': 'k&k solar gmbh'
}], [1502, {
    'name': 'Kaindl-Reiling GmbH',
    'description': '',
    'city': 'Königsbach-Stein',
    'id': 1502,
    'blockId': 15,
    'queryName': 'kaindl-reiling gmbh'
}], [7409, {
    'name': 'Karner Düngerproduktion GmbH',
    'description': '',
    'city': 'Stuttgart',
    'id': 7409,
    'blockId': 74,
    'queryName': 'karner düngerproduktion gmbh'
}], [4111, {
    'name': 'Kaupp Landmaschinen GmbH',
    'description': '',
    'city': 'Schwindegg',
    'id': 4111,
    'blockId': 41,
    'queryName': 'kaupp landmaschinen gmbh'
}], [1702, {
    'name': 'Kempf Fassadenvertrieb e. K.',
    'description': '',
    'city': 'Malching',
    'id': 1702,
    'blockId': 17,
    'queryName': 'kempf fassadenvertrieb e. k.'
}], [3723, {
    'name': 'Kerbl GmbH',
    'description': '',
    'city': 'Buchbach',
    'id': 3723,
    'blockId': 37,
    'queryName': 'kerbl gmbh'
}], [2401, {
    'name': 'Kersia Deutschland GmbH',
    'description': '',
    'city': 'Wesseling',
    'id': 2401,
    'blockId': 24,
    'queryName': 'kersia deutschland gmbh'
}], [8601, {
    'name': 'Kiefl Stalltechnik',
    'description': '',
    'city': 'Rain',
    'id': 8601,
    'blockId': 86,
    'queryName': 'kiefl stalltechnik'
}], [1130, {
    'name': 'Kinderparadies',
    'description': '',
    'city': 'Fichtenau',
    'id': 1130,
    'blockId': 11,
    'queryName': 'kinderparadies'
}], [1709, {
    'name': 'Kirschner Metallbau',
    'description': '',
    'city': 'Wurmannsquick',
    'id': 1709,
    'blockId': 17,
    'queryName': 'kirschner metallbau'
}], [1120, {
    'name': 'KKL Küchenhandels-GmbH',
    'description': '',
    'city': 'Hebertsfelden',
    'id': 1120,
    'blockId': 11,
    'queryName': 'kkl küchenhandels-gmbh'
}], [3702, {
    'name': 'Klein Service GmbH',
    'description': '',
    'city': 'Jettingen',
    'id': 3702,
    'blockId': 37,
    'queryName': 'klein service gmbh'
}], [4507, {
    'name': 'Landwirtschaftsverlag GmbH',
    'description': '',
    'city': 'Münster',
    'id': 4507,
    'blockId': 45,
    'queryName': 'landwirtschaftsverlag gmbh'
}], [1414, {
    'name': 'Lang',
    'description': '',
    'city': 'Ortenburg',
    'id': 1414,
    'blockId': 14,
    'queryName': 'lang'
}], [8902, {
    'name': 'Laxhuber GmbH',
    'description': '',
    'city': 'Massing',
    'id': 8902,
    'blockId': 89,
    'queryName': 'laxhuber gmbh'
}], [1213, {
    'name': 'Lederhilger GmbH',
    'description': '',
    'city': 'Sipbachzell',
    'id': 1213,
    'blockId': 12,
    'queryName': 'lederhilger gmbh'
}], [3410, {
    'name': 'LEHNER Maschinenbau GmbH',
    'description': '',
    'city': 'Westerstetten',
    'id': 3410,
    'blockId': 34,
    'queryName': 'lehner maschinenbau gmbh'
}], [1102, {
    'name': 'Leipfinger Bader GmbH',
    'description': '',
    'city': 'Vatersdorf',
    'id': 1102,
    'blockId': 11,
    'queryName': 'leipfinger bader gmbh'
}], [8101, {
    'name': 'Lemken GmbH & Co KG',
    'description': '',
    'city': 'Alpen',
    'id': 8101,
    'blockId': 81,
    'queryName': 'lemken gmbh & co kg'
}], [8202, {
    'name': 'Ley Maschinen GmbH',
    'description': '',
    'city': 'Lengau',
    'id': 8202,
    'blockId': 82,
    'queryName': 'ley maschinen gmbh'
}], [7502, {
    'name': 'Lidea',
    'description': '',
    'city': 'Norderstedt',
    'id': 7502,
    'blockId': 75,
    'queryName': 'lidea'
}], [1200, {
    'name': 'Liebl',
    'description': '',
    'city': 'Kötzting',
    'id': 1200,
    'blockId': 12,
    'queryName': 'liebl'
}], [1205, {
    'name': 'Liedl',
    'description': '',
    'city': 'Pfarrkirchen',
    'id': 1205,
    'blockId': 12,
    'queryName': 'liedl'
}], [7516, {
    'name': 'Limagrain GmbH',
    'description': '',
    'city': 'Edemissen',
    'id': 7516,
    'blockId': 75,
    'queryName': 'limagrain gmbh'
}], [3420, {
    'name': 'Lindlbauer',
    'description': '',
    'city': 'Rossbach',
    'id': 3420,
    'blockId': 34,
    'queryName': 'lindlbauer'
}], [1503, {
    'name': 'Lindner GFT GmbH',
    'description': '',
    'city': 'Arnstorf',
    'id': 1503,
    'blockId': 15,
    'queryName': 'lindner gft gmbh'
}], [3714, {
    'name': 'Lindner GmbH',
    'description': '',
    'city': 'Kundl',
    'id': 3714,
    'blockId': 37,
    'queryName': 'lindner gmbh'
}], [5902, {
    'name': 'Lochner Forsttechnik GmbH & Co. KG',
    'description': '',
    'city': 'Insingen',
    'id': 5902,
    'blockId': 59,
    'queryName': 'lochner forsttechnik gmbh & co. kg'
}], [2412, {
    'name': 'Löw Wasertechnik UG',
    'description': '',
    'city': 'Rotthalmünster',
    'id': 2412,
    'blockId': 24,
    'queryName': 'löw wasertechnik ug'
}], [1222, {
    'name': 'Lotter',
    'description': '',
    'city': 'Ammerndorf',
    'id': 1222,
    'blockId': 12,
    'queryName': 'lotter'
}], [5709, {
    'name': 'Pfanzelt-Maschinenbau GmbH',
    'description': '',
    'city': 'Rettenbach',
    'id': 5709,
    'blockId': 57,
    'queryName': 'pfanzelt-maschinenbau gmbh'
}], [4106, {
    'name': 'Pfister Waagen Bilanciai GmbH',
    'description': '',
    'city': 'Affing-Mühlhausen',
    'id': 4106,
    'blockId': 41,
    'queryName': 'pfister waagen bilanciai gmbh'
}], [3731, {
    'name': 'PG Schmierstoffe',
    'description': '',
    'city': 'Brunnenthal',
    'id': 3731,
    'blockId': 37,
    'queryName': 'pg schmierstoffe'
}], [1513, {
    'name': 'Pieroth Deutschland GmbH',
    'description': '',
    'city': 'Burg Layen',
    'id': 1513,
    'blockId': 15,
    'queryName': 'pieroth deutschland gmbh'
}], [2511, {
    'name': 'Pioneer Hi-Bred NE Sales Division GmbH',
    'description': '',
    'city': 'München',
    'id': 2511,
    'blockId': 25,
    'queryName': 'pioneer hi-bred ne sales division gmbh'
}], [1706, {
    'name': 'Pirate Grills',
    'description': '',
    'city': 'Egglham',
    'id': 1706,
    'blockId': 17,
    'queryName': 'pirate grills'
}], [1313, {
    'name': 'Pirchner',
    'description': '',
    'city': 'Schechen',
    'id': 1313,
    'blockId': 13,
    'queryName': 'pirchner'
}], [5701, {
    'name': 'Pisek - Vitli Krpan d.o.o.',
    'description': '',
    'city': 'Smarje Pri Jelsah',
    'id': 5701,
    'blockId': 57,
    'queryName': 'pisek - vitli krpan d.o.o.'
}], [8602, {
    'name': 'Plantan GmbH',
    'description': '',
    'city': 'Buchholz',
    'id': 8602,
    'blockId': 86,
    'queryName': 'plantan gmbh'
}], [2503, {
    'name': 'Plattner',
    'description': '',
    'city': 'Künzing',
    'id': 2503,
    'blockId': 25,
    'queryName': 'plattner'
}], [2509, {
    'name': 'Plendl Lenksysteme',
    'description': '',
    'city': 'Oberschneiding',
    'id': 2509,
    'blockId': 25,
    'queryName': 'plendl lenksysteme'
}], [1324, {
    'name': 'Plura',
    'description': '',
    'city': 'Friedberg',
    'id': 1324,
    'blockId': 13,
    'queryName': 'plura'
}], [2407, {
    'name': 'Pneuhage',
    'description': '',
    'city': 'Karlsruhe',
    'id': 2407,
    'blockId': 24,
    'queryName': 'pneuhage'
}], [2105, {
    'name': 'Pöttinger Landtechnik GmbH',
    'description': '',
    'city': 'Grieskirchen',
    'id': 2105,
    'blockId': 21,
    'queryName': 'pöttinger landtechnik gmbh'
}], [2102, {
    'name': 'Pöttinger Landtechnik GmbH',
    'description': '',
    'city': 'Grieskirchen',
    'id': 2102,
    'blockId': 21,
    'queryName': 'pöttinger landtechnik gmbh'
}], [5301, {
    'name': 'Posch GmbH',
    'description': '',
    'city': 'Velden/Vils',
    'id': 5301,
    'blockId': 53,
    'queryName': 'posch gmbh'
}], [1227, {
    'name': 'Prado-Berlin',
    'description': '',
    'city': 'Berlin',
    'id': 1227,
    'blockId': 12,
    'queryName': 'prado-berlin'
}], [1119, {
    'name': 'Preisinger',
    'description': '',
    'city': 'Pfarrkirchen',
    'id': 1119,
    'blockId': 11,
    'queryName': 'preisinger'
}], [5706, {
    'name': 'Preiß Landtechnik',
    'description': '',
    'city': 'Bad Kötzting',
    'id': 5706,
    'blockId': 57,
    'queryName': 'preiß landtechnik'
}], [3413, {
    'name': 'Pressol Schmiergeräte GmbH',
    'description': '',
    'city': 'Falkenstein',
    'id': 3413,
    'blockId': 34,
    'queryName': 'pressol schmiergeräte gmbh'
}], [7302, {
    'name': 'Prinzing GmbH',
    'description': '',
    'city': 'Lonsee-Urspring',
    'id': 7302,
    'blockId': 73,
    'queryName': 'prinzing gmbh'
}], [3742, {
    'name': 'Probst Agrartechnik GmbH',
    'description': '',
    'city': 'Valley',
    'id': 3742,
    'blockId': 37,
    'queryName': 'probst agrartechnik gmbh'
}], [4209, {
    'name': 'ROPA',
    'description': '',
    'city': 'Herrngiersdorf',
    'id': 4209,
    'blockId': 42,
    'queryName': 'ropa'
}], [1217, {
    'name': 'Rotel GmbH',
    'description': '',
    'city': 'Attendorn',
    'id': 1217,
    'blockId': 12,
    'queryName': 'rotel gmbh'
}], [3201, {
    'name': 'Rothaichner',
    'description': '',
    'city': 'Rimbach',
    'id': 3201,
    'blockId': 32,
    'queryName': 'rothaichner'
}], [3730, {
    'name': 'Rubner Holzbau GmbH',
    'description': '',
    'city': 'Ober-Grafendorf',
    'id': 3730,
    'blockId': 37,
    'queryName': 'rubner holzbau gmbh'
}], [1704, {
    'name': 'Rußwurm',
    'description': '',
    'city': 'Frasdorf',
    'id': 1704,
    'blockId': 17,
    'queryName': 'rußwurm'
}], [7509, {
    'name': 'Saatbau Linz eGen',
    'description': '',
    'city': 'Leonding',
    'id': 7509,
    'blockId': 75,
    'queryName': 'saatbau linz egen'
}], [1703, {
    'name': 'Sachs GmbH & Co.',
    'description': '',
    'city': 'Bad Birnbach',
    'id': 1703,
    'blockId': 17,
    'queryName': 'sachs gmbh & co.'
}], [7202, {
    'name': 'SALVANA Tiernahrung GmbH',
    'description': '',
    'city': 'Wertingen',
    'id': 7202,
    'blockId': 72,
    'queryName': 'salvana tiernahrung gmbh'
}], [5513, {
    'name': 'SAM Power GmbH',
    'description': '',
    'city': 'Lengenbostel',
    'id': 5513,
    'blockId': 55,
    'queryName': 'sam power gmbh'
}], [2512, {
    'name': 'Samson Agro A/S',
    'description': '',
    'city': 'Viborg',
    'id': 2512,
    'blockId': 25,
    'queryName': 'samson agro a/s'
}], [4408, {
    'name': 'Saphir Maschinenbau GmbH',
    'description': '',
    'city': 'Gyhum-Bockel',
    'id': 4408,
    'blockId': 44,
    'queryName': 'saphir maschinenbau gmbh'
}], [4102, {
    'name': 'Schachner GmbH',
    'description': '',
    'city': 'Tiefenbach',
    'id': 4102,
    'blockId': 41,
    'queryName': 'schachner gmbh'
}], [4102, {
    'name': 'Schachner GmbH',
    'description': '',
    'city': 'Tiefenbach',
    'id': 4102,
    'blockId': 41,
    'queryName': 'schachner gmbh'
}], [1312, {
    'name': 'Schätzl GmbH',
    'description': '',
    'city': 'Moosburg',
    'id': 1312,
    'blockId': 13,
    'queryName': 'schätzl gmbh'
}], [8802, {
    'name': 'Schauer',
    'description': '',
    'city': 'Pfettrach',
    'id': 8802,
    'blockId': 88,
    'queryName': 'schauer'
}], [7204, {
    'name': 'Schauer Maschinenfab. GmbH',
    'description': '',
    'city': 'Pocking',
    'id': 7204,
    'blockId': 72,
    'queryName': 'schauer maschinenfab. gmbh'
}], [7301, {
    'name': 'Schaumann GmbH',
    'description': '',
    'city': 'Pinneberg',
    'id': 7301,
    'blockId': 73,
    'queryName': 'schaumann gmbh'
}], [5703, {
    'name': 'Scheifele Forsttechnik GmbH',
    'description': '',
    'city': 'Bretzfeld',
    'id': 5703,
    'blockId': 57,
    'queryName': 'scheifele forsttechnik gmbh'
}], [5709, {
    'name': 'Schlang & Reichart',
    'description': '',
    'city': 'Rettenbach',
    'id': 5709,
    'blockId': 57,
    'queryName': 'schlang & reichart'
}], [3728, {
    'name': 'Schleker',
    'description': '',
    'city': 'Ehingen-Scheiblishausen',
    'id': 3728,
    'blockId': 37,
    'queryName': 'schleker'
}], [3401, {
    'name': 'Schlögl Fahrzeugbau GmbH',
    'description': '',
    'city': 'Pfarrkirchen',
    'id': 3401,
    'blockId': 34,
    'queryName': 'schlögl fahrzeugbau gmbh'
}], [1330, {
    'name': 'Schmid',
    'description': '',
    'city': 'Regenstauf',
    'id': 1330,
    'blockId': 13,
    'queryName': 'schmid'
}], [3743, {
    'name': 'Schmid Fahrzeugbau GmbH',
    'description': '',
    'city': 'Haag i. OB',
    'id': 3743,
    'blockId': 37,
    'queryName': 'schmid fahrzeugbau gmbh'
}], [4301, {
    'name': 'Schmotzer Hacktechnik GmbH & Co. KG',
    'description': '',
    'city': 'Bad Windsheim',
    'id': 4301,
    'blockId': 43,
    'queryName': 'schmotzer hacktechnik gmbh & co. kg'
}], [1309, {
    'name': 'Schneider',
    'description': '',
    'city': 'Rotthalmünster',
    'id': 1309,
    'blockId': 13,
    'queryName': 'schneider'
}], [2411, {
    'name': 'Schneidhuber',
    'description': '',
    'city': 'Tettenweis',
    'id': 2411,
    'blockId': 24,
    'queryName': 'schneidhuber'
}], [2409, {
    'name': 'Schneller Provetec GmbH',
    'description': '',
    'city': 'Hainsfahrt',
    'id': 2409,
    'blockId': 24,
    'queryName': 'schneller provetec gmbh'
}], [5702, {
    'name': 'Schnitzhofer Ges.m.b.H.',
    'description': '',
    'city': 'Annaberg',
    'id': 5702,
    'blockId': 57,
    'queryName': 'schnitzhofer ges.m.b.h.'
}], [8805, {
    'name': 'SchönbergerLandtechnik GmbH',
    'description': '',
    'city': 'Mitterskirchen',
    'id': 8805,
    'blockId': 88,
    'queryName': 'schönbergerlandtechnik gmbh'
}], [1102, {
    'name': 'Schwaiger J. u. A.  GbR',
    'description': '',
    'city': 'Pocking',
    'id': 1102,
    'blockId': 11,
    'queryName': 'schwaiger j. u. a.  gbr'
}], [2006, {
    'name': 'Schwanheimer Industriekleber',
    'description': '',
    'city': 'Schwanheim',
    'id': 2006,
    'blockId': 20,
    'queryName': 'schwanheimer industriekleber'
}], [2402, {
    'name': 'Schwarz GmbH',
    'description': '',
    'city': 'Wallersdorf',
    'id': 2402,
    'blockId': 24,
    'queryName': 'schwarz gmbh'
}], [8607, {
    'name': 'Schwarz GmbH',
    'description': '',
    'city': 'Töging',
    'id': 8607,
    'blockId': 86,
    'queryName': 'schwarz gmbh'
}], [1301, {
    'name': 'Schwiewagner',
    'description': '',
    'city': 'Tiefenbach',
    'id': 1301,
    'blockId': 13,
    'queryName': 'schwiewagner'
}], [5201, {
    'name': 'Seibold',
    'description': '',
    'city': 'Baiernrain',
    'id': 5201,
    'blockId': 52,
    'queryName': 'seibold'
}], [1710, {
    'name': 'Sekro GmbH & Co. KG',
    'description': '',
    'city': 'Bad Kötzting',
    'id': 1710,
    'blockId': 17,
    'queryName': 'sekro gmbh & co. kg'
}]];
